// tslint:disable
/* MACLE TypeScript 17/07/2025 17:31:48 */
import { BaseData, BaseDataDisplay, ESexo, DataEndereco, ETipoFrete, EStatusPedidoSite } from './maf.vo';
import { ArrayList } from 'maf-web';

export class PKPagamentoPIXAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKPagamentoPIXAPP";
  codPagamentoPIX: number = 0;

  constructor()
  constructor(codPagamentoPIX: number)
  constructor(codPagamentoPIX?: number) {
    super();
    this.codPagamentoPIX = codPagamentoPIX || 0;
  }

  public getPK(): PKPagamentoPIXAPP {
    return new PKPagamentoPIXAPP(this.codPagamentoPIX);
  }

  public equals(arg: PKPagamentoPIXAPP): boolean {
    return arg 
        && (arg.codPagamentoPIX === this.codPagamentoPIX)
    ;
  }
}


export class PKLiquidacaoParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKLiquidacaoParcelaAPP";
  codLiquidacaoParcela: number = 0;

  constructor()
  constructor(codLiquidacaoParcela: number)
  constructor(codLiquidacaoParcela?: number) {
    super();
    this.codLiquidacaoParcela = codLiquidacaoParcela || 0;
  }

  public getPK(): PKLiquidacaoParcelaAPP {
    return new PKLiquidacaoParcelaAPP(this.codLiquidacaoParcela);
  }

  public equals(arg: PKLiquidacaoParcelaAPP): boolean {
    return arg 
        && (arg.codLiquidacaoParcela === this.codLiquidacaoParcela)
    ;
  }
}


export class PKContaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKContaAPP";
  codEmpresa: number = 0;
  codConta: number = 0;

  constructor()
  constructor(codEmpresa: number, codConta: number)
  constructor(codEmpresa?: number, codConta?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.codConta = codConta || 0;
  }

  public getPK(): PKContaAPP {
    return new PKContaAPP(this.codEmpresa, this.codConta);
  }

  public equals(arg: PKContaAPP): boolean {
    return arg 
        && (arg.codEmpresa === this.codEmpresa)
        && (arg.codConta === this.codConta)
    ;
  }
}


export class PKVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKVendaAPP";
  codVenda: number = 0;

  constructor()
  constructor(codVenda: number)
  constructor(codVenda?: number) {
    super();
    this.codVenda = codVenda || 0;
  }

  public getPK(): PKVendaAPP {
    return new PKVendaAPP(this.codVenda);
  }

  public equals(arg: PKVendaAPP): boolean {
    return arg 
        && (arg.codVenda === this.codVenda)
    ;
  }
}


export class DataPagamentoPIXAPP extends PKPagamentoPIXAPP {
  readonly jclass: string = "com.macle.app.vo.DataPagamentoPIXAPP";
  codEmpresa: number = 0;
  liquidacaoParcela: PKLiquidacaoParcelaAPP = new PKLiquidacaoParcelaAPP();
  dataHoraValidoAte: string = "";
  conta: PKContaAPP = new PKContaAPP();
  idCobranca: string = "";
  venda: PKVendaAPP = new PKVendaAPP();
  pago: boolean = false;
  transactionId: string = "";
  idPedido: string = "";
}


export class DataUrlParametrosAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataUrlParametrosAPP";
  codVitrine: number = 0;
  codVendedor: number = 0;
  codEmpVendedor: number = 0;
  itens: string[] = [];
  codEmpresaVenda: number = 0;
}


export class LVPedStatsSO extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedStatsSO";
  SO: string = "";
}


export class PKPedido extends BaseData {
  readonly jclass: string = "com.macle.site.vo.PKPedido";
  codPedido: number = 0;

  constructor()
  constructor(codPedido: number)
  constructor(codPedido?: number) {
    super();
    this.codPedido = codPedido || 0;
  }

  public getPK(): PKPedido {
    return new PKPedido(this.codPedido);
  }

  public equals(arg: PKPedido): boolean {
    return arg 
        && (arg.codPedido === this.codPedido)
    ;
  }
}


export class BaseTransp extends BaseData {
  readonly jclass: string = "com.macle.site.vo.BaseTransp";
  codLOG: number = 0;

  constructor()
  constructor(codLOG: number)
  constructor(codLOG?: number) {
    super();
    this.codLOG = codLOG || 0;
  }

  public getPK(): BaseTransp {
    return new BaseTransp(this.codLOG);
  }

  public equals(arg: BaseTransp): boolean {
    return arg 
        && (arg.codLOG === this.codLOG)
    ;
  }
}


export class LVPKItem extends BaseTransp {
  readonly jclass: string = "com.macle.site.vo.LVPKItem";
  codItem: number = 0;
  codEmpresa: number = 0;

  constructor()
  constructor(codLOG: number, codEmpresa: number, codItem: number)
  constructor(codLOG?: number, codEmpresa?: number, codItem?: number) {
    super();
    this.codLOG = codLOG || 0;
    this.codEmpresa = codEmpresa || 0;
    this.codItem = codItem || 0;
  }

  public getPK(): LVPKItem {
    return new LVPKItem(this.codLOG, this.codEmpresa, this.codItem);
  }

  public equals(arg: LVPKItem): boolean {
    return arg && super.equals(arg)
        && (arg.codItem === this.codItem)
        && (arg.codEmpresa === this.codEmpresa)
    ;
  }
}


export class LVCorItem extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVCorItem";
  codItem: LVPKItem = new LVPKItem();
  descCor: string = "";
  codCor: number = 0;
}


export class LVDataTamanho extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVDataTamanho";
  codTamanho: number = 0;
  qtdEstoque: number = 0;
  ordem: number = 0;
  descTamanho: string = "";
  EAN: string = "";
}


export class LVPedItem extends PKPedido {
  readonly jclass: string = "com.macle.site.vo.LVPedItem";
  descricao: string = "";
  codItem: LVPKItem = new LVPKItem();
  qtd: number = 0;
  cor: LVCorItem = new LVCorItem();
  embalar: boolean = false;
  precoUnit: number = 0;
  tamanho: LVDataTamanho = new LVDataTamanho();
}


export class EFormaPagamentoAPP {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EFormaPagamentoAPP = new EFormaPagamentoAPP("0");
  get NONE() {
    return EFormaPagamentoAPP.NONE;
  }

  static readonly BOLETO: EFormaPagamentoAPP = new EFormaPagamentoAPP("1");
  get BOLETO() {
    return EFormaPagamentoAPP.BOLETO;
  }

  static readonly CARTAO: EFormaPagamentoAPP = new EFormaPagamentoAPP("2");
  get CARTAO() {
    return EFormaPagamentoAPP.CARTAO;
  }

  static readonly CREDIARIO: EFormaPagamentoAPP = new EFormaPagamentoAPP("3");
  get CREDIARIO() {
    return EFormaPagamentoAPP.CREDIARIO;
  }

  static readonly CONDICIONAL: EFormaPagamentoAPP = new EFormaPagamentoAPP("4");
  get CONDICIONAL() {
    return EFormaPagamentoAPP.CONDICIONAL;
  }

  static readonly PIX: EFormaPagamentoAPP = new EFormaPagamentoAPP("5");
  get PIX() {
    return EFormaPagamentoAPP.PIX;
  }

  static readonly MARKETPLACE: EFormaPagamentoAPP = new EFormaPagamentoAPP("6");
  get MARKETPLACE() {
    return EFormaPagamentoAPP.MARKETPLACE;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Boleto";
      case "2": return "Cart&atilde;o";
      case "3": return "Credi&aacute;rio";
      case "4": return "Condicional";
      case "5": return "PIX";
      case "6": return "Marketplace";
      default: return "";
    }
  }

  public equals(arg: EFormaPagamentoAPP): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EFormaPagamentoAPP[] = [this.NONE,this.BOLETO,this.CARTAO,this.CREDIARIO,this.CONDICIONAL,this.PIX,this.MARKETPLACE];
}


export class PKPagarMeTransacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKPagarMeTransacaoAPP";
  codPagarMeTransacao: number = 0;

  constructor()
  constructor(codPagarMeTransacao: number)
  constructor(codPagarMeTransacao?: number) {
    super();
    this.codPagarMeTransacao = codPagarMeTransacao || 0;
  }

  public getPK(): PKPagarMeTransacaoAPP {
    return new PKPagarMeTransacaoAPP(this.codPagarMeTransacao);
  }

  public equals(arg: PKPagarMeTransacaoAPP): boolean {
    return arg 
        && (arg.codPagarMeTransacao === this.codPagarMeTransacao)
    ;
  }
}


export class PKClienteAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKClienteAPP";
  codCliente: number = 0;
  codEmpresaCliente: number = 0;

  constructor()
  constructor(codEmpresaCliente: number, codCliente: number)
  constructor(codEmpresaCliente?: number, codCliente?: number) {
    super();
    this.codEmpresaCliente = codEmpresaCliente || 0;
    this.codCliente = codCliente || 0;
  }

  public getPK(): PKClienteAPP {
    return new PKClienteAPP(this.codEmpresaCliente, this.codCliente);
  }

  public equals(arg: PKClienteAPP): boolean {
    return arg 
        && (arg.codCliente === this.codCliente)
        && (arg.codEmpresaCliente === this.codEmpresaCliente)
    ;
  }
}


export class PKDependenteAPP extends PKClienteAPP {
  readonly jclass: string = "com.macle.app.vo.PKDependenteAPP";
  codDependente: number = 0;

  constructor()
  constructor(codEmpresaCliente: number, codCliente: number, codDependente: number)
  constructor(codEmpresaCliente?: number, codCliente?: number, codDependente?: number) {
    super();
    this.codEmpresaCliente = codEmpresaCliente || 0;
    this.codCliente = codCliente || 0;
    this.codDependente = codDependente || 0;
  }

  public getPK(): PKDependenteAPP {
    return new PKDependenteAPP(this.codEmpresaCliente, this.codCliente, this.codDependente);
  }

  public equals(arg: PKDependenteAPP): boolean {
    return arg && super.equals(arg)
        && (arg.codDependente === this.codDependente)
    ;
  }
}


export class EStatusPagarMeTransacaoAPP {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP("0");
  get NONE() {
    return EStatusPagarMeTransacaoAPP.NONE;
  }

  static readonly PROCESSING: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP("1");
  get PROCESSING() {
    return EStatusPagarMeTransacaoAPP.PROCESSING;
  }

  static readonly AUTHORIZED: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP("2");
  get AUTHORIZED() {
    return EStatusPagarMeTransacaoAPP.AUTHORIZED;
  }

  static readonly PAID: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP("3");
  get PAID() {
    return EStatusPagarMeTransacaoAPP.PAID;
  }

  static readonly REFUNDED: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP("4");
  get REFUNDED() {
    return EStatusPagarMeTransacaoAPP.REFUNDED;
  }

  static readonly WAITING_PAYMENT: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP("5");
  get WAITING_PAYMENT() {
    return EStatusPagarMeTransacaoAPP.WAITING_PAYMENT;
  }

  static readonly PENDING_REFUND: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP("6");
  get PENDING_REFUND() {
    return EStatusPagarMeTransacaoAPP.PENDING_REFUND;
  }

  static readonly REFUSED: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP("7");
  get REFUSED() {
    return EStatusPagarMeTransacaoAPP.REFUSED;
  }

  static readonly CHARGEDBACK: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP("8");
  get CHARGEDBACK() {
    return EStatusPagarMeTransacaoAPP.CHARGEDBACK;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "Nenhum";
      case "1": return "processing";
      case "2": return "authorized";
      case "3": return "paid";
      case "4": return "refunded";
      case "5": return "waiting_payment";
      case "6": return "pending_refund";
      case "7": return "refused";
      case "8": return "chargedback";
      default: return "";
    }
  }

  public equals(arg: EStatusPagarMeTransacaoAPP): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EStatusPagarMeTransacaoAPP[] = [this.NONE,this.PROCESSING,this.AUTHORIZED,this.PAID,this.REFUNDED,this.WAITING_PAYMENT,this.PENDING_REFUND,this.REFUSED,this.CHARGEDBACK];
}


export class EStatusPedidoCartaoCreditoPagarmeAPP {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("0");
  get NONE() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.NONE;
  }

  static readonly authorized_pending_capture: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("1");
  get authorized_pending_capture() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.authorized_pending_capture;
  }

  static readonly not_authorized: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("2");
  get not_authorized() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.not_authorized;
  }

  static readonly captured: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("3");
  get captured() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.captured;
  }

  static readonly partial_capture: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("4");
  get partial_capture() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.partial_capture;
  }

  static readonly waiting_capture: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("5");
  get waiting_capture() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.waiting_capture;
  }

  static readonly refunded: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("6");
  get refunded() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.refunded;
  }

  static readonly voided: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("7");
  get voided() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.voided;
  }

  static readonly partial_refunded: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("8");
  get partial_refunded() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.partial_refunded;
  }

  static readonly partial_void: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("9");
  get partial_void() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.partial_void;
  }

  static readonly error_on_voiding: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("10");
  get error_on_voiding() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.error_on_voiding;
  }

  static readonly error_on_refunding: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("11");
  get error_on_refunding() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.error_on_refunding;
  }

  static readonly waiting_cancellation: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("12");
  get waiting_cancellation() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.waiting_cancellation;
  }

  static readonly with_error: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("13");
  get with_error() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.with_error;
  }

  static readonly failed: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("14");
  get failed() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.failed;
  }

  static readonly waiting_payment: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("15");
  get waiting_payment() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.waiting_payment;
  }

  static readonly paid: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("16");
  get paid() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.paid;
  }

  static readonly pending: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("17");
  get pending() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.pending;
  }

  static readonly pending_refuded: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("18");
  get pending_refuded() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.pending_refuded;
  }

  static readonly generated: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("19");
  get generated() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.generated;
  }

  static readonly viewed: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("20");
  get viewed() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.viewed;
  }

  static readonly underpaid: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("21");
  get underpaid() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.underpaid;
  }

  static readonly overpaid: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("22");
  get overpaid() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.overpaid;
  }

  static readonly processing: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("23");
  get processing() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.processing;
  }

  static readonly canceled: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP("24");
  get canceled() {
    return EStatusPedidoCartaoCreditoPagarmeAPP.canceled;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "authorized_pending_capture";
      case "2": return "not_authorized";
      case "3": return "captured";
      case "4": return "partial_capture";
      case "5": return "waiting_capture";
      case "6": return "refunded";
      case "7": return "voided";
      case "8": return "partial_refunded";
      case "9": return "partial_void";
      case "10": return "error_on_voiding";
      case "11": return "error_on_refunding";
      case "12": return "waiting_cancellation";
      case "13": return "with_error";
      case "14": return "failed";
      case "15": return "waiting_payment";
      case "16": return "paid";
      case "17": return "pending";
      case "18": return "pending_refuded";
      case "19": return "generated";
      case "20": return "viewed";
      case "21": return "underpaid";
      case "22": return "overpaid";
      case "23": return "processing";
      case "24": return "canceled";
      default: return "";
    }
  }

  public equals(arg: EStatusPedidoCartaoCreditoPagarmeAPP): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EStatusPedidoCartaoCreditoPagarmeAPP[] = [this.NONE,this.authorized_pending_capture,this.not_authorized,this.captured,this.partial_capture,this.waiting_capture,this.refunded,this.voided,this.partial_refunded,this.partial_void,this.error_on_voiding,this.error_on_refunding,this.waiting_cancellation,this.with_error,this.failed,this.waiting_payment,this.paid,this.pending,this.pending_refuded,this.generated,this.viewed,this.underpaid,this.overpaid,this.processing,this.canceled];
}


export class DataPagarMeTransacaoAPP extends PKPagarMeTransacaoAPP {
  readonly jclass: string = "com.macle.app.vo.DataPagarMeTransacaoAPP";
  data: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  hora: string = "";
  status: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP();
  idCobranca: string = "";
  idTransacao: number = 0;
  statusCartao: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP();
  idPedido: string = "";
  jsonTransacao: string = "";
}


export class DataVendaClienteAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaClienteAPP";
  dataNascimento: string = "";
  telefone: string = "";
  cnpj: string = "";
  nome: string = "";
  email: string = "";
  sexo: ESexo = new ESexo();
  cliente: PKDependenteAPP = new PKDependenteAPP();
  dadosResumido: boolean = false;
  inscEstadual: string = "";
}


export class PKPedidoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKPedidoVit";
  codPedido: number = 0;

  constructor()
  constructor(codPedido: number)
  constructor(codPedido?: number) {
    super();
    this.codPedido = codPedido || 0;
  }

  public getPK(): PKPedidoVit {
    return new PKPedidoVit(this.codPedido);
  }

  public equals(arg: PKPedidoVit): boolean {
    return arg 
        && (arg.codPedido === this.codPedido)
    ;
  }
}


export class DataPedidoClienteVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteVit";
  dataNascimento: string = "";
  telefone: string = "";
  cnpj: string = "";
  nome: string = "";
  email: string = "";
  sexo: ESexo = new ESexo();
  cliente: PKDependenteAPP = new PKDependenteAPP();
  inscEstadual: string = "";
}


export class EVersaoIntegracaoPagarmeAPP {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EVersaoIntegracaoPagarmeAPP = new EVersaoIntegracaoPagarmeAPP("0");
  get NONE() {
    return EVersaoIntegracaoPagarmeAPP.NONE;
  }

  static readonly V2: EVersaoIntegracaoPagarmeAPP = new EVersaoIntegracaoPagarmeAPP("1");
  get V2() {
    return EVersaoIntegracaoPagarmeAPP.V2;
  }

  static readonly V5: EVersaoIntegracaoPagarmeAPP = new EVersaoIntegracaoPagarmeAPP("2");
  get V5() {
    return EVersaoIntegracaoPagarmeAPP.V5;
  }

  static readonly V6: EVersaoIntegracaoPagarmeAPP = new EVersaoIntegracaoPagarmeAPP("3");
  get V6() {
    return EVersaoIntegracaoPagarmeAPP.V6;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Pagar.me V2";
      case "2": return "Pagar.me V5";
      case "3": return "Zoop";
      default: return "";
    }
  }

  public equals(arg: EVersaoIntegracaoPagarmeAPP): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EVersaoIntegracaoPagarmeAPP[] = [this.NONE,this.V2,this.V5,this.V6];
}


export class ETipoConfirmacaoConsumidorSiteAPP {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: ETipoConfirmacaoConsumidorSiteAPP = new ETipoConfirmacaoConsumidorSiteAPP("0");
  get NONE() {
    return ETipoConfirmacaoConsumidorSiteAPP.NONE;
  }

  static readonly SMS: ETipoConfirmacaoConsumidorSiteAPP = new ETipoConfirmacaoConsumidorSiteAPP("1");
  get SMS() {
    return ETipoConfirmacaoConsumidorSiteAPP.SMS;
  }

  static readonly EMAIL: ETipoConfirmacaoConsumidorSiteAPP = new ETipoConfirmacaoConsumidorSiteAPP("2");
  get EMAIL() {
    return ETipoConfirmacaoConsumidorSiteAPP.EMAIL;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "Nenhum";
      case "1": return "SMS";
      case "2": return "EMAIL";
      default: return "";
    }
  }

  public equals(arg: ETipoConfirmacaoConsumidorSiteAPP): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ETipoConfirmacaoConsumidorSiteAPP[] = [this.NONE,this.SMS,this.EMAIL];
}


export class ConsTamanhoItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsTamanhoItemAPP";
  descricao: string = "";
  codTamanho: number = 0;
  disponivel: boolean = false;

  constructor()
  constructor(codTamanho: number, descricao: string, disponivel: boolean)
  constructor(codTamanho?: number, descricao?: string, disponivel?: boolean) {
    super();
    this.codTamanho = codTamanho || 0;
    this.descricao = descricao || "";
    this.disponivel = disponivel || false;
  }

  public getPK(): ConsTamanhoItemAPP {
    return new ConsTamanhoItemAPP(this.codTamanho, this.descricao, this.disponivel);
  }

  public equals(arg: ConsTamanhoItemAPP): boolean {
    return arg 
        && (arg.descricao === this.descricao)
        && (arg.codTamanho === this.codTamanho)
        && (arg.disponivel === this.disponivel)
    ;
  }
}


export class DataFrenetShippingItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingItemVit";
  length: number = 0;
  height: number = 0;
  weight: number = 0;
  width: number = 0;
  quantity: number = 0;
  category: string = "";
  SKU: string = "";
}


export class DataFrenetShippingVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingVit";
  shippingServiceCode: string = "";
  sellerCEP: string = "";
  recipientCEP: string = "";
  recipientCountry: string = "";
  shippingItemArray: ArrayList<DataFrenetShippingItemVit> = new ArrayList<DataFrenetShippingItemVit>(DataFrenetShippingItemVit);
  shipmentInvoiceValue: number = 0;
}


export class PKClienteMacleVitPub extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKClienteMacleVitPub";
  codClienteMacle: number = 0;
}


export class PKPedidoVitPub extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKPedidoVitPub";
  clienteMacle: PKClienteMacleVitPub = new PKClienteMacleVitPub();

  constructor()
  constructor(codPedido: number, clienteMacle: PKClienteMacleVitPub)
  constructor(codPedido?: number, clienteMacle?: PKClienteMacleVitPub) {
    super();
    this.codPedido = codPedido || 0;
    this.clienteMacle = clienteMacle ||  new PKClienteMacleVitPub();
  }

  public getPK(): PKPedidoVitPub {
    return new PKPedidoVitPub(this.codPedido, this.clienteMacle);
  }

  public equals(arg: PKPedidoVitPub): boolean {
    return arg && super.equals(arg)
        && (arg.clienteMacle === this.clienteMacle)
    ;
  }
}


export class ETipoFreteAPP {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: ETipoFreteAPP = new ETipoFreteAPP("0");
  get NONE() {
    return ETipoFreteAPP.NONE;
  }

  static readonly SEDEX: ETipoFreteAPP = new ETipoFreteAPP("1");
  get SEDEX() {
    return ETipoFreteAPP.SEDEX;
  }

  static readonly PAC: ETipoFreteAPP = new ETipoFreteAPP("2");
  get PAC() {
    return ETipoFreteAPP.PAC;
  }

  static readonly ENVIO_FLEX_ML: ETipoFreteAPP = new ETipoFreteAPP("3");
  get ENVIO_FLEX_ML() {
    return ETipoFreteAPP.ENVIO_FLEX_ML;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Sedex";
      case "2": return "PAC";
      case "3": return "Envio Flex";
      default: return "";
    }
  }

  public equals(arg: ETipoFreteAPP): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ETipoFreteAPP[] = [this.NONE,this.SEDEX,this.PAC,this.ENVIO_FLEX_ML];
}


export class DataFreteAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataFreteAPP";
  prazoEntrega: string = "";
  indisponivel: boolean = false;
  valorFrete: number = 0;
  tipoFrete: ETipoFreteAPP = new ETipoFreteAPP();
}


export class DataEntregaDistanciaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEntregaDistanciaAPP";
  duracaoViagemSegundos: number = 0;
  destino: string = "";
  distanciaKM: number = 0;
  origem: string = "";
}


export class DataPedidoEntregaVitPub extends PKPedidoVitPub {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaVitPub";
  frete: DataFreteAPP = new DataFreteAPP();
  codEmpresaRetiradaLoja: number = 0;
  distancia: DataEntregaDistanciaAPP = new DataEntregaDistanciaAPP();
  taxaEntrega: number = 0;
  retiradaLoja: boolean = false;
}


export class DataResultEmitePixVendaPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataResultEmitePixVendaPagarMeAPP";
  pkTransacao: PKPagarMeTransacaoAPP = new PKPagarMeTransacaoAPP();
  dataHoraValidade: string = "";
  pkPIX: PKPagamentoPIXAPP = new PKPagamentoPIXAPP();
  qr_code_url: string = "";
  qr_code: string = "";
  valorPIX: number = 0;
}


export class PKItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKItemAPP";
  codItem: number = 0;
  codEmpItem: number = 0;

  constructor()
  constructor(codEmpItem: number, codItem: number)
  constructor(codEmpItem?: number, codItem?: number) {
    super();
    this.codEmpItem = codEmpItem || 0;
    this.codItem = codItem || 0;
  }

  public getPK(): PKItemAPP {
    return new PKItemAPP(this.codEmpItem, this.codItem);
  }

  public equals(arg: PKItemAPP): boolean {
    return arg 
        && (arg.codItem === this.codItem)
        && (arg.codEmpItem === this.codEmpItem)
    ;
  }
}


export class PKTamanhoItemAPP extends PKItemAPP {
  readonly jclass: string = "com.macle.app.vo.PKTamanhoItemAPP";
  codTamanho: number = 0;

  constructor()
  constructor(codEmpItem: number, codItem: number, codTamanho: number)
  constructor(codEmpItem?: number, codItem?: number, codTamanho?: number) {
    super();
    this.codEmpItem = codEmpItem || 0;
    this.codItem = codItem || 0;
    this.codTamanho = codTamanho || 0;
  }

  public getPK(): PKTamanhoItemAPP {
    return new PKTamanhoItemAPP(this.codEmpItem, this.codItem, this.codTamanho);
  }

  public equals(arg: PKTamanhoItemAPP): boolean {
    return arg && super.equals(arg)
        && (arg.codTamanho === this.codTamanho)
    ;
  }
}


export class DataPrecoVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataPrecoVendaAPP";
  promocao: boolean = false;
  codEmpresa: number = 0;
  congelado: boolean = false;
  precoVenda: number = 0;
  dataAlter: string = "";
  dataIniPromo: string = "";
  dataFimPromo: string = "";
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
  precoAlter: number = 0;
  vlrPromo: number = 0;
}


export class PKZoopTransacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKZoopTransacaoAPP";
  codZoopTransacao: number = 0;

  constructor()
  constructor(codZoopTransacao: number)
  constructor(codZoopTransacao?: number) {
    super();
    this.codZoopTransacao = codZoopTransacao || 0;
  }

  public getPK(): PKZoopTransacaoAPP {
    return new PKZoopTransacaoAPP(this.codZoopTransacao);
  }

  public equals(arg: PKZoopTransacaoAPP): boolean {
    return arg 
        && (arg.codZoopTransacao === this.codZoopTransacao)
    ;
  }
}


export class LVPedEndereco extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedEndereco";
  endereco: string = "";
  bairro: string = "";
  numero: string = "";
  CEP: number = 0;
  cidade: string = "";
  estado: string = "";
  infReferencia: string = "";
  retirarLoja: boolean = false;
  descricaoEndereco: string = "";
}


export class DataPedidoShippingML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoShippingML";
  id: number = 0;
}


export class DataShareItemAPP extends PKItemAPP {
  readonly jclass: string = "com.macle.app.vo.DataShareItemAPP";
  imgNome: string = "";
  descItem: string = "";
  imgBase64: string = "";
}


export class DataFrenetEnderecoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetEnderecoVit";
  country: string = "";
  city: string = "";
  postalBoxCode: string = "";
  addressNumber: string = "";
  addressState: string = "";
  zipCode: string = "";
  street: string = "";
  addressQuarter: string = "";
  enderecoCompleto: boolean = false;
  addressComplement: string = "";
}


export class DataFrenetPedidoEtiquetaClienteVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaClienteVit";
  address: DataFrenetEnderecoVit = new DataFrenetEnderecoVit();
  name: string = "";
  email: string = "";
  document: string = "";
  cellphone: string = "";
  phone: string = "";
  IE: string = "";
}


export class DataFrenetPedidoEtiquetaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaItemVit";
  length: number = 0;
  height: number = 0;
  weight: number = 0;
  width: number = 0;
  fragile: boolean = false;
  orderId: string = "";
  itemId: string = "";
  sku: string = "";
  productName: string = "";
  quantity: number = 0;
  category: string = "";
  productType: string = "";
  price: number = 0;
  productId: string = "";
  productOptions: string = "";
}


export class DataFrenetPedidoEtiquetaNotaVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaNotaVit";
  value: number = 0;
  key: string = "";
  number: string = "";
  date: string = "";
  series: string = "";
  CFOP: string = "";
}


export class DataFrenetPedidoEtiquetaOrdemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaOrdemVit";
  value: number = 0;
  id: string = "";
  created: string = "";
  from: DataFrenetPedidoEtiquetaClienteVit = new DataFrenetPedidoEtiquetaClienteVit();
  items: ArrayList<DataFrenetPedidoEtiquetaItemVit> = new ArrayList<DataFrenetPedidoEtiquetaItemVit>(DataFrenetPedidoEtiquetaItemVit);
  to: DataFrenetPedidoEtiquetaClienteVit = new DataFrenetPedidoEtiquetaClienteVit();
  invoice: DataFrenetPedidoEtiquetaNotaVit = new DataFrenetPedidoEtiquetaNotaVit();
  useFrenetRegistration: boolean = false;
}


export class DataResultEmiteVendaPixPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataResultEmiteVendaPixPagarMeAPP";
  dataHoraValidade: string = "";
  statusPix: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP();
  pkPIX: PKPagamentoPIXAPP = new PKPagamentoPIXAPP();
  qr_code_url: string = "";
  qr_code: string = "";
  valorPIX: number = 0;
}


export class EArredondPrc {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EArredondPrc = new EArredondPrc("0");
  get NONE() {
    return EArredondPrc.NONE;
  }

  static readonly ZERO: EArredondPrc = new EArredondPrc("1");
  get ZERO() {
    return EArredondPrc.ZERO;
  }

  static readonly CINQUENTA: EArredondPrc = new EArredondPrc("2");
  get CINQUENTA() {
    return EArredondPrc.CINQUENTA;
  }

  static readonly OITENTA: EArredondPrc = new EArredondPrc("3");
  get OITENTA() {
    return EArredondPrc.OITENTA;
  }

  static readonly OITO_NOVE: EArredondPrc = new EArredondPrc("9");
  get OITO_NOVE() {
    return EArredondPrc.OITO_NOVE;
  }

  static readonly NOVENTA: EArredondPrc = new EArredondPrc("4");
  get NOVENTA() {
    return EArredondPrc.NOVENTA;
  }

  static readonly NOV_CINCO: EArredondPrc = new EArredondPrc("7");
  get NOV_CINCO() {
    return EArredondPrc.NOV_CINCO;
  }

  static readonly NOV_OITO: EArredondPrc = new EArredondPrc("8");
  get NOV_OITO() {
    return EArredondPrc.NOV_OITO;
  }

  static readonly NOV_NOVE: EArredondPrc = new EArredondPrc("5");
  get NOV_NOVE() {
    return EArredondPrc.NOV_NOVE;
  }

  static readonly DEC_CENTAVOS: EArredondPrc = new EArredondPrc("6");
  get DEC_CENTAVOS() {
    return EArredondPrc.DEC_CENTAVOS;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "Nenhum";
      case "1": return "*,00";
      case "2": return "*,50";
      case "3": return "*,80";
      case "9": return "*,89";
      case "4": return "*,90";
      case "7": return "*,95";
      case "8": return "*,98";
      case "5": return "*,99";
      case "6": return "*,*0";
      default: return "";
    }
  }

  public equals(arg: EArredondPrc): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EArredondPrc[] = [this.NONE,this.ZERO,this.CINQUENTA,this.OITENTA,this.OITO_NOVE,this.NOVENTA,this.NOV_CINCO,this.NOV_OITO,this.NOV_NOVE,this.DEC_CENTAVOS];
}


export class PKDocVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKDocVendaAPP";
  numero: number = 0;
  codEmpresa: number = 0;
  serie: number = 0;

  constructor()
  constructor(codEmpresa: number, serie: number, numero: number)
  constructor(codEmpresa?: number, serie?: number, numero?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.serie = serie || 0;
    this.numero = numero || 0;
  }

  public getPK(): PKDocVendaAPP {
    return new PKDocVendaAPP(this.codEmpresa, this.serie, this.numero);
  }

  public equals(arg: PKDocVendaAPP): boolean {
    return arg 
        && (arg.numero === this.numero)
        && (arg.codEmpresa === this.codEmpresa)
        && (arg.serie === this.serie)
    ;
  }
}


export class DataFreteVitrineServico extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFreteVitrineServico";
  nome: string = "";
  indisponivel: boolean = false;
  codigo: string = "";
  valorEntrega: number = 0;
  diasEntrega: number = 0;
}


export class LVPKVendedor extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPKVendedor";
  codEmpresa: number = 0;
  codFuncionario: number = 0;

  constructor()
  constructor(codEmpresa: number, codFuncionario: number)
  constructor(codEmpresa?: number, codFuncionario?: number) {
    super();
    this.codEmpresa = codEmpresa || 0;
    this.codFuncionario = codFuncionario || 0;
  }

  public getPK(): LVPKVendedor {
    return new LVPKVendedor(this.codEmpresa, this.codFuncionario);
  }

  public equals(arg: LVPKVendedor): boolean {
    return arg 
        && (arg.codEmpresa === this.codEmpresa)
        && (arg.codFuncionario === this.codFuncionario)
    ;
  }
}


export class LVDataVendedor extends LVPKVendedor {
  readonly jclass: string = "com.macle.site.vo.LVDataVendedor";
}


export class DataNovoClienteAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataNovoClienteAPP";
  telefone: string = "";
  nome: string = "";
  endereco: string = "";
  email: string = "";
  bairro: string = "";
  numero: string = "";
  cidade: string = "";
  uf: string = "";
  complemento: string = "";
  nascimento: string = "";
  cpf: string = "";
  cep: string = "";
}


export class ConsClienteAPP extends PKDependenteAPP {
  readonly jclass: string = "com.macle.app.vo.ConsClienteAPP";
  regraMinimaAtiva: boolean = false;
  dataNascimento: string = "";
  crediarioLiberado: boolean = false;
  dadosResumidos: boolean = false;
  telefone: string = "";
  cnpj: string = "";
  clienteNovo: boolean = false;
  nome: string = "";
  qtdItens: number = 0;
  pontos: number = 0;
  endereco: DataEndereco = new DataEndereco();
  limiteCredito: number = 0;
  email: string = "";
  qtdParcAtivas: number = 0;
  sexo: ESexo = new ESexo();
  qtdParcVencida: number = 0;
  totalLimiteCredito: number = 0;
}


export class ConsImgItemAPP extends LVPKItem {
  readonly jclass: string = "com.macle.app.vo.ConsImgItemAPP";
  imagens: string[] = [];
}


export class PKVendedorAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKVendedorAPP";
  codVendedor: number = 0;
  codEmpVendedor: number = 0;

  constructor()
  constructor(codEmpVendedor: number, codVendedor: number)
  constructor(codEmpVendedor?: number, codVendedor?: number) {
    super();
    this.codEmpVendedor = codEmpVendedor || 0;
    this.codVendedor = codVendedor || 0;
  }

  public getPK(): PKVendedorAPP {
    return new PKVendedorAPP(this.codEmpVendedor, this.codVendedor);
  }

  public equals(arg: PKVendedorAPP): boolean {
    return arg 
        && (arg.codVendedor === this.codVendedor)
        && (arg.codEmpVendedor === this.codEmpVendedor)
    ;
  }
}


export class DataResultEmiteCartaoDeCreditoPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataResultEmiteCartaoDeCreditoPagarMeAPP";
  nomeTitular: string = "";
  bandeira: string = "";
  status: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP();
  qtdParcelas: number = 0;
  pkTransacao: PKPagarMeTransacaoAPP = new PKPagarMeTransacaoAPP();
  primeirosDigitos: string = "";
  ultimosDigitos: string = "";
}


export class DataPedidoEnderecoVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEnderecoVit";
  endereco: DataEndereco = new DataEndereco();
}


export class EFormaPagto {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EFormaPagto = new EFormaPagto("0");
  get NONE() {
    return EFormaPagto.NONE;
  }

  static readonly VISA: EFormaPagto = new EFormaPagto("1");
  get VISA() {
    return EFormaPagto.VISA;
  }

  static readonly MASTERCAR: EFormaPagto = new EFormaPagto("2");
  get MASTERCAR() {
    return EFormaPagto.MASTERCAR;
  }

  static readonly DINNERS: EFormaPagto = new EFormaPagto("3");
  get DINNERS() {
    return EFormaPagto.DINNERS;
  }

  static readonly AMERICANEXPRESS: EFormaPagto = new EFormaPagto("4");
  get AMERICANEXPRESS() {
    return EFormaPagto.AMERICANEXPRESS;
  }

  static readonly HIPERCARD: EFormaPagto = new EFormaPagto("5");
  get HIPERCARD() {
    return EFormaPagto.HIPERCARD;
  }

  static readonly BANCO_BRADESCO: EFormaPagto = new EFormaPagto("6");
  get BANCO_BRADESCO() {
    return EFormaPagto.BANCO_BRADESCO;
  }

  static readonly BANCO_BRASIL: EFormaPagto = new EFormaPagto("7");
  get BANCO_BRASIL() {
    return EFormaPagto.BANCO_BRASIL;
  }

  static readonly BANCO_ITAU: EFormaPagto = new EFormaPagto("8");
  get BANCO_ITAU() {
    return EFormaPagto.BANCO_ITAU;
  }

  static readonly BOLETO: EFormaPagto = new EFormaPagto("9");
  get BOLETO() {
    return EFormaPagto.BOLETO;
  }

  static readonly AMERICANEXPRESS_PAGSEGURO: EFormaPagto = new EFormaPagto("10");
  get AMERICANEXPRESS_PAGSEGURO() {
    return EFormaPagto.AMERICANEXPRESS_PAGSEGURO;
  }

  static readonly HIPERCARD_PAGSEGURO: EFormaPagto = new EFormaPagto("11");
  get HIPERCARD_PAGSEGURO() {
    return EFormaPagto.HIPERCARD_PAGSEGURO;
  }

  static readonly ITAU_PAGSEGURO: EFormaPagto = new EFormaPagto("12");
  get ITAU_PAGSEGURO() {
    return EFormaPagto.ITAU_PAGSEGURO;
  }

  static readonly BRADESCO_PAGSEGURO: EFormaPagto = new EFormaPagto("13");
  get BRADESCO_PAGSEGURO() {
    return EFormaPagto.BRADESCO_PAGSEGURO;
  }

  static readonly UNIBANCO_PAGSEGURO: EFormaPagto = new EFormaPagto("14");
  get UNIBANCO_PAGSEGURO() {
    return EFormaPagto.UNIBANCO_PAGSEGURO;
  }

  static readonly BANCOREAL_PAGSEGURO: EFormaPagto = new EFormaPagto("15");
  get BANCOREAL_PAGSEGURO() {
    return EFormaPagto.BANCOREAL_PAGSEGURO;
  }

  static readonly AURA_PAGSEGURO: EFormaPagto = new EFormaPagto("16");
  get AURA_PAGSEGURO() {
    return EFormaPagto.AURA_PAGSEGURO;
  }

  static readonly BANCOBRASIL_PAGSEGURO: EFormaPagto = new EFormaPagto("17");
  get BANCOBRASIL_PAGSEGURO() {
    return EFormaPagto.BANCOBRASIL_PAGSEGURO;
  }

  static readonly ELO: EFormaPagto = new EFormaPagto("18");
  get ELO() {
    return EFormaPagto.ELO;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Cart&amp;atilde;o Visa";
      case "2": return "Cart&amp;atilde;o MasterCard";
      case "3": return "Cart&amp;atilde;o Dinners";
      case "4": return "Cart&amp;atilde;o American Express";
      case "5": return "Cart&amp;atilde;o Hipercard";
      case "6": return "Banco Bradesco";
      case "7": return "Banco do Brasil";
      case "8": return "Banco Ita&amp;uacute;";
      case "9": return "Boleto";
      case "10": return "American Express - Pag Seguro";
      case "11": return "Hipercard - Pag Seguro";
      case "12": return "Ita&amp;uacute; - Pag Seguro";
      case "13": return "Bradesco - Pag Seguro";
      case "14": return "Unibanco - Pag Seguro";
      case "15": return "Banco Real - Pag Seguro";
      case "16": return "Aura - Pag Seguro";
      case "17": return "Banco do Brasil - Pag Seguro";
      case "18": return "Elo";
      default: return "";
    }
  }

  public equals(arg: EFormaPagto): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EFormaPagto[] = [this.NONE,this.VISA,this.MASTERCAR,this.DINNERS,this.AMERICANEXPRESS,this.HIPERCARD,this.BANCO_BRADESCO,this.BANCO_BRASIL,this.BANCO_ITAU,this.BOLETO,this.AMERICANEXPRESS_PAGSEGURO,this.HIPERCARD_PAGSEGURO,this.ITAU_PAGSEGURO,this.BRADESCO_PAGSEGURO,this.UNIBANCO_PAGSEGURO,this.BANCOREAL_PAGSEGURO,this.AURA_PAGSEGURO,this.BANCOBRASIL_PAGSEGURO,this.ELO];
}


export class LVDataTransacaoCieloResult extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVDataTransacaoCieloResult";
  codigoCaptura: number = 0;
  tidTransacao: string = "";
  panTransacao: string = "";
  horaTransacao: string = "";
  dataTransacao: string = "";
  lrAutorisacao: string = "";
  parcelasFormaPagto: number = 0;
  statusAutorizacao: number = 0;
  statusTransacao: number = 0;
  codPedidoTransacao: number = 0;
  mensagemAutorisacao: string = "";
  produtoFormaPagto: string = "";
  nsuAutorisacao: string = "";
  mensagemCaptura: string = "";
  arpAutorisacao: string = "";
  bandeiraTransacao: EFormaPagto = new EFormaPagto();
  valorTransacao: number = 0;
}


export class PKParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKParcelaAPP";
  codParcela: number = 0;
  codEmpresaParcela: number = 0;

  constructor()
  constructor(codEmpresaParcela: number, codParcela: number)
  constructor(codEmpresaParcela?: number, codParcela?: number) {
    super();
    this.codEmpresaParcela = codEmpresaParcela || 0;
    this.codParcela = codParcela || 0;
  }

  public getPK(): PKParcelaAPP {
    return new PKParcelaAPP(this.codEmpresaParcela, this.codParcela);
  }

  public equals(arg: PKParcelaAPP): boolean {
    return arg 
        && (arg.codParcela === this.codParcela)
        && (arg.codEmpresaParcela === this.codEmpresaParcela)
    ;
  }
}


export class EStatusLiquidacaoAPP {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EStatusLiquidacaoAPP = new EStatusLiquidacaoAPP("0");
  get NONE() {
    return EStatusLiquidacaoAPP.NONE;
  }

  static readonly PENDENTE: EStatusLiquidacaoAPP = new EStatusLiquidacaoAPP("1");
  get PENDENTE() {
    return EStatusLiquidacaoAPP.PENDENTE;
  }

  static readonly LIQUIDADO: EStatusLiquidacaoAPP = new EStatusLiquidacaoAPP("2");
  get LIQUIDADO() {
    return EStatusLiquidacaoAPP.LIQUIDADO;
  }

  static readonly EXPIRADA: EStatusLiquidacaoAPP = new EStatusLiquidacaoAPP("3");
  get EXPIRADA() {
    return EStatusLiquidacaoAPP.EXPIRADA;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Pendente";
      case "2": return "Liquidado";
      case "3": return "Expirada";
      default: return "";
    }
  }

  public equals(arg: EStatusLiquidacaoAPP): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EStatusLiquidacaoAPP[] = [this.NONE,this.PENDENTE,this.LIQUIDADO,this.EXPIRADA];
}


export class DataLiquidacaoParcelaAPP extends PKLiquidacaoParcelaAPP {
  readonly jclass: string = "com.macle.app.vo.DataLiquidacaoParcelaAPP";
  data: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  codEmpresa: number = 0;
  formaPagamento: EFormaPagamentoAPP = new EFormaPagamentoAPP();
  qrCodePIXBase64: string = "";
  versaointegracao: EVersaoIntegracaoPagarmeAPP = new EVersaoIntegracaoPagarmeAPP();
  dataHoraValidadePIX: string = "";
  barcodeBoleto: string = "";
  valor: number = 0;
  urlBoleto: string = "";
  ativo: boolean = false;
  hora: string = "";
  conta: PKContaAPP = new PKContaAPP();
  listParcela: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  lineBoleto: string = "";
  vencimento: string = "";
  status: EStatusLiquidacaoAPP = new EStatusLiquidacaoAPP();
  qrCodePIX: string = "";
  enviadoSistema: boolean = false;
  transactionId: string = "";
  idPedido: string = "";
}


export class DataFrenetEtiquetaErroVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetEtiquetaErroVit";
  message: string = "";
  code: number = 0;
}


export class DataFrenetPedidoEtiquetaItemResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaItemResponseVit";
  orderId: string = "";
  validThrough: string = "";
  errors: ArrayList<DataFrenetEtiquetaErroVit> = new ArrayList<DataFrenetEtiquetaErroVit>(DataFrenetEtiquetaErroVit);
  shipmentId: number = 0;
  trackingUrl: string = "";
  labelUrl: string = "";
  declarationUrl: string = "";
  shipmentStatus: number = 0;
  receiptNotificationUrl: string = "";
}


export class DataPedidoItemVariacaoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemVariacaoML";
  name: string = "";
  id: string = "";
  value_id: string = "";
  value_name: string = "";
}


export class DataPedidoItemDadosML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemDadosML";
  id: string = "";
  category_id: string = "";
  title: string = "";
  warranty: string = "";
  variation_id: number = 0;
  seller_sku: string = "";
  variation_attributes: ArrayList<DataPedidoItemVariacaoML> = new ArrayList<DataPedidoItemVariacaoML>(DataPedidoItemVariacaoML);
}


export class ConsLojaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsLojaAPP";
  bairro: string = "";
  fantasia: string = "";
  numero: string = "";
  logradouro: string = "";
  CEP: number = 0;
  UF: string = "";
  cidade: string = "";
  codEmpresa: number = 0;
}


export class ConsVendedorAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsVendedorAPP";
  nome: string = "";
  whatsApp: number = 0;
  fotoBase64: string = "";
  codVendedor: number = 0;
  listEmpresa: number[] = [];
  codEmpVendedor: number = 0;
}


export class ConsLojasComVendedorAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsLojasComVendedorAPP";
  listLoja: ArrayList<ConsLojaAPP> = new ArrayList<ConsLojaAPP>(ConsLojaAPP);
  listVendedor: ArrayList<ConsVendedorAPP> = new ArrayList<ConsVendedorAPP>(ConsVendedorAPP);
}


export class PKVendaVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKVendaVit";
  codVenda: number = 0;

  constructor()
  constructor(codVenda: number)
  constructor(codVenda?: number) {
    super();
    this.codVenda = codVenda || 0;
  }

  public getPK(): PKVendaVit {
    return new PKVendaVit(this.codVenda);
  }

  public equals(arg: PKVendaVit): boolean {
    return arg 
        && (arg.codVenda === this.codVenda)
    ;
  }
}


export class PKItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemVit";
  codItemVit: number = 0;

  constructor()
  constructor(codItemVit: number)
  constructor(codItemVit?: number) {
    super();
    this.codItemVit = codItemVit || 0;
  }

  public getPK(): PKItemVit {
    return new PKItemVit(this.codItemVit);
  }

  public equals(arg: PKItemVit): boolean {
    return arg 
        && (arg.codItemVit === this.codItemVit)
    ;
  }
}


export class PKItemLojaVitPub extends PKItemVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemLojaVitPub";
  clienteMacle: PKClienteMacleVitPub = new PKClienteMacleVitPub();

  constructor()
  constructor(codItemVit: number, clienteMacle: PKClienteMacleVitPub)
  constructor(codItemVit?: number, clienteMacle?: PKClienteMacleVitPub) {
    super();
    this.codItemVit = codItemVit || 0;
    this.clienteMacle = clienteMacle ||  new PKClienteMacleVitPub();
  }

  public getPK(): PKItemLojaVitPub {
    return new PKItemLojaVitPub(this.codItemVit, this.clienteMacle);
  }

  public equals(arg: PKItemLojaVitPub): boolean {
    return arg && super.equals(arg)
        && (arg.clienteMacle === this.clienteMacle)
    ;
  }
}


export class PKItemControleVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemControleVit";
  codItemControle: number = 0;
  codEmpresaControle: number = 0;

  constructor()
  constructor(codEmpresaControle: number, codItemControle: number)
  constructor(codEmpresaControle?: number, codItemControle?: number) {
    super();
    this.codEmpresaControle = codEmpresaControle || 0;
    this.codItemControle = codItemControle || 0;
  }

  public getPK(): PKItemControleVit {
    return new PKItemControleVit(this.codEmpresaControle, this.codItemControle);
  }

  public equals(arg: PKItemControleVit): boolean {
    return arg 
        && (arg.codItemControle === this.codItemControle)
        && (arg.codEmpresaControle === this.codEmpresaControle)
    ;
  }
}


export class DataVendaItemVitPub extends PKItemLojaVitPub {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaItemVitPub";
  descricao: string = "";
  codTamanho: number = 0;
  descricaoTamanho: string = "";
  qtd: number = 0;
  desconto: number = 0;
  precoUnitario: number = 0;
  precoCongelado: boolean = false;
  itemControle: PKItemControleVit = new PKItemControleVit();
  imgPequenoBase64: string = "";
}


export class DataVendaVitPub extends PKVendaVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaVitPub";
  data: string = "";
  valor: number = 0;
  hora: string = "";
  codVitrineVenda: number = 0;
  codEmpresaVenda: number = 0;
  desconto: number = 0;
  listItem: ArrayList<DataVendaItemVitPub> = new ArrayList<DataVendaItemVitPub>(DataVendaItemVitPub);
  vendedor: PKVendedorAPP = new PKVendedorAPP();
}


export class LVPKClienteSite extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPKClienteSite";
  codCliente: number = 0;
  codDependente: number = 0;
  codEmpCli: number = 0;
  codSite: number = 0;

  constructor()
  constructor(codSite: number, codEmpCli: number, codCliente: number, codDependente: number)
  constructor(codSite?: number, codEmpCli?: number, codCliente?: number, codDependente?: number) {
    super();
    this.codSite = codSite || 0;
    this.codEmpCli = codEmpCli || 0;
    this.codCliente = codCliente || 0;
    this.codDependente = codDependente || 0;
  }

  public getPK(): LVPKClienteSite {
    return new LVPKClienteSite(this.codSite, this.codEmpCli, this.codCliente, this.codDependente);
  }

  public equals(arg: LVPKClienteSite): boolean {
    return arg 
        && (arg.codCliente === this.codCliente)
        && (arg.codDependente === this.codDependente)
        && (arg.codEmpCli === this.codEmpCli)
        && (arg.codSite === this.codSite)
    ;
  }
}


export class LVPedCliente extends LVPKClienteSite {
  readonly jclass: string = "com.macle.site.vo.LVPedCliente";
  dataNascimento: string = "";
  email: string = "";
  sexo: ESexo = new ESexo();
  enderecoEntrega: LVPedEndereco = new LVPedEndereco();
  vendedor: LVDataVendedor = new LVDataVendedor();
  CPF: string = "";
  telCelular: string = "";
  nomeCli: string = "";
  senha: string = "";
  telResidencial: string = "";
  enderecoCobranca: LVPedEndereco = new LVPedEndereco();
}


export class DataRetirarLojaVitrinePubAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataRetirarLojaVitrinePubAPP";
  fantasia: string = "";
  codClienteMacle: number = 0;
  lojasComVendedor: ConsLojasComVendedorAPP = new ConsLojasComVendedorAPP();
}


export class DataShareAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataShareAPP";
  url: string = "";
  itens: ArrayList<DataShareItemAPP> = new ArrayList<DataShareItemAPP>(DataShareItemAPP);
}


export class DataPedidoClienteDocumentoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteDocumentoML";
  value: string = "";
  id: string = "";
}


export class DataEnderecoAuxML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataEnderecoAuxML";
  name: string = "";
  id: string = "";
}


export class DataEnderecoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataEnderecoML";
  state: DataEnderecoAuxML = new DataEnderecoAuxML();
  country: DataEnderecoAuxML = new DataEnderecoAuxML();
  comment: string = "";
  street_name: string = "";
  street_number: string = "";
  zip_code: string = "";
  receiver_name: string = "";
  city: DataEnderecoAuxML = new DataEnderecoAuxML();
  neighborhood: DataEnderecoAuxML = new DataEnderecoAuxML();
}


export class DataPedidoClienteDocumentoAdicionalML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteDocumentoAdicionalML";
  value: string = "";
  type: string = "";
}


export class DataPedidoClienteReceiverML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteReceiverML";
  name: string = "";
  id: number = 0;
  city_ibge: string = "";
  document: DataPedidoClienteDocumentoML = new DataPedidoClienteDocumentoML();
  billing_address: DataEnderecoML = new DataEnderecoML();
  additional_documents: ArrayList<DataPedidoClienteDocumentoAdicionalML> = new ArrayList<DataPedidoClienteDocumentoAdicionalML>(DataPedidoClienteDocumentoAdicionalML);
}


export class DataPedidoClienteML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoClienteML";
  receiver: DataPedidoClienteReceiverML = new DataPedidoClienteReceiverML();
}


export class DataResultEmitePixZoopAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataResultEmitePixZoopAPP";
  dataHoraValidade: string = "";
  qr_code_url: string = "";
  pkLiquidacao: PKLiquidacaoParcelaAPP = new PKLiquidacaoParcelaAPP();
  qr_code: string = "";
  valorPIX: number = 0;
}


export class DataResultEmiteBoletoPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataResultEmiteBoletoPagarMeAPP";
  barcodeBoleto: string = "";
  urlBoleto: string = "";
  pkTransacao: PKPagarMeTransacaoAPP = new PKPagarMeTransacaoAPP();
  valorBoleto: number = 0;
  vencimentoBoleto: string = "";
}


export class PKCondVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.PKCondVendaAPP";
  codEmpresaCondVenda: number = 0;
  codCondVenda: number = 0;

  constructor()
  constructor(codEmpresaCondVenda: number, codCondVenda: number)
  constructor(codEmpresaCondVenda?: number, codCondVenda?: number) {
    super();
    this.codEmpresaCondVenda = codEmpresaCondVenda || 0;
    this.codCondVenda = codCondVenda || 0;
  }

  public getPK(): PKCondVendaAPP {
    return new PKCondVendaAPP(this.codEmpresaCondVenda, this.codCondVenda);
  }

  public equals(arg: PKCondVendaAPP): boolean {
    return arg 
        && (arg.codEmpresaCondVenda === this.codEmpresaCondVenda)
        && (arg.codCondVenda === this.codCondVenda)
    ;
  }
}


export class DataPedidoFormaPagamentoVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoFormaPagamentoVit";
  formaPagamento: EFormaPagamentoAPP = new EFormaPagamentoAPP();
  cartao: DataResultEmiteCartaoDeCreditoPagarMeAPP = new DataResultEmiteCartaoDeCreditoPagarMeAPP();
  pix: DataResultEmiteVendaPixPagarMeAPP = new DataResultEmiteVendaPixPagarMeAPP();
  boleto: DataResultEmiteBoletoPagarMeAPP = new DataResultEmiteBoletoPagarMeAPP();
  condVenda: PKCondVendaAPP = new PKCondVendaAPP();
}


export class DataPedidoPagarMeTransacaoVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoPagarMeTransacaoVit";
  data: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  codPagarMeTransacao: number = 0;
  hora: string = "";
  status: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP();
  idCobranca: string = "";
  idTransacao: number = 0;
  idPedido: string = "";
  jsonTransacao: string = "";
}


export class DataPedidoItemVitPub extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemVitPub";
  descricao: string = "";
  itemVit: PKItemLojaVitPub = new PKItemLojaVitPub();
  qtd: number = 0;
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
  desconto: number = 0;
  precoUnitario: number = 0;
}


export class DataPedidoLojaPub extends PKPedidoVitPub {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoLojaPub";
  status: EStatusPedidoSite = new EStatusPedidoSite();
  nroetiquetasigep: string = "";
  horaUltimoUpdate: string = "";
  dataUltimoUpdate: string = "";
  dataCancelamento: string = "";
}


export class DataPedidoVitPub extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoVitPub";
  data: string = "";
  cliente: DataPedidoClienteVit = new DataPedidoClienteVit();
  formaPagamento: DataPedidoFormaPagamentoVit = new DataPedidoFormaPagamentoVit();
  valor: number = 0;
  hora: string = "";
  enviadoSistema: boolean = false;
  pagarMeTransacao: DataPedidoPagarMeTransacaoVit = new DataPedidoPagarMeTransacaoVit();
  enderecoEntrega: DataPedidoEnderecoVit = new DataPedidoEnderecoVit();
  desconto: number = 0;
  listItem: ArrayList<DataPedidoItemVitPub> = new ArrayList<DataPedidoItemVitPub>(DataPedidoItemVitPub);
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  listEntrega: ArrayList<DataPedidoEntregaVitPub> = new ArrayList<DataPedidoEntregaVitPub>(DataPedidoEntregaVitPub);
  listPedidoLoja: ArrayList<DataPedidoLojaPub> = new ArrayList<DataPedidoLojaPub>(DataPedidoLojaPub);
  codEmpresaPedido: number = 0;
  acrescimo: number = 0;
}


export class ConsCondVendaAPP extends PKCondVendaAPP {
  readonly jclass: string = "com.macle.app.vo.ConsCondVendaAPP";
  descricao: string = "";
  trintaDiasDireto: boolean = false;
  diaPrimeiraParc: number = 0;
  dataPrimParc: string = "";
  numParcelas: number = 0;
  diaVencto: number = 0;
  arredond: EArredondPrc = new EArredondPrc();
  pctEntrada: number = 0;
  diaEntreParc: number = 0;
  pctAcres: number = 0;
  pctDesc: number = 0;
  forceVlrParc: number = 0;
}


export class DataCanSelectParcelaApp extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataCanSelectParcelaApp";
  marcadas: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  parcela: PKParcelaAPP = new PKParcelaAPP();
}


export class LVPedFormaPagto extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedFormaPagto";
  nome: string = "";
  formaPagamento: EFormaPagto = new EFormaPagto();
  codSeguranca: string = "";
  nroParcelas: number = 0;
  numCartao: string = "";
  valAno: string = "";
  valMes: string = "";
}


export class PKTamanhoItemVit extends PKItemVit {
  readonly jclass: string = "com.macle.vitrine.vo.PKTamanhoItemVit";
  codTamanho: number = 0;

  constructor()
  constructor(codItemVit: number, codTamanho: number)
  constructor(codItemVit?: number, codTamanho?: number) {
    super();
    this.codItemVit = codItemVit || 0;
    this.codTamanho = codTamanho || 0;
  }

  public getPK(): PKTamanhoItemVit {
    return new PKTamanhoItemVit(this.codItemVit, this.codTamanho);
  }

  public equals(arg: PKTamanhoItemVit): boolean {
    return arg && super.equals(arg)
        && (arg.codTamanho === this.codTamanho)
    ;
  }
}


export class DataVendaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaItemVit";
  descricao: string = "";
  descricaoTamanho: string = "";
  qtd: number = 0;
  item: PKTamanhoItemVit = new PKTamanhoItemVit();
  precoTotalItem: number = 0;
  desconto: number = 0;
  valorLiquido: number = 0;
  precoUnitario: number = 0;
  precoCongelado: boolean = false;
  itemControle: PKItemControleVit = new PKItemControleVit();
  descricaoMarca: string = "";
  gtin: string = "";
  imgPequenoURL: string = "";
  descricaoCor: string = "";
  googleCategory: string = "";

  constructor()
  constructor(item: PKTamanhoItemVit, gtin: string, descricaoTamanho: string, itemControle: PKItemControleVit, descricao: string, googleCategory: string, descricaoCor: string, descricaoMarca: string, imgPequenoURL: string, qtd: number, precoUnitario: number, desconto: number, precoCongelado: boolean)
  constructor(item?: PKTamanhoItemVit, gtin?: string, descricaoTamanho?: string, itemControle?: PKItemControleVit, descricao?: string, googleCategory?: string, descricaoCor?: string, descricaoMarca?: string, imgPequenoURL?: string, qtd?: number, precoUnitario?: number, desconto?: number, precoCongelado?: boolean) {
    super();
    this.item = item ||  new PKTamanhoItemVit();
    this.gtin = gtin || "";
    this.descricaoTamanho = descricaoTamanho || "";
    this.itemControle = itemControle ||  new PKItemControleVit();
    this.descricao = descricao || "";
    this.googleCategory = googleCategory || "";
    this.descricaoCor = descricaoCor || "";
    this.descricaoMarca = descricaoMarca || "";
    this.imgPequenoURL = imgPequenoURL || "";
    this.qtd = qtd || 0;
    this.precoUnitario = precoUnitario || 0;
    this.desconto = desconto || 0;
    this.precoCongelado = precoCongelado || false;
  }

  public getPK(): DataVendaItemVit {
    return new DataVendaItemVit(this.item, this.gtin, this.descricaoTamanho, this.itemControle, this.descricao, this.googleCategory, this.descricaoCor, this.descricaoMarca, this.imgPequenoURL, this.qtd, this.precoUnitario, this.desconto, this.precoCongelado);
  }

  public equals(arg: DataVendaItemVit): boolean {
    return arg 
        && (arg.descricao === this.descricao)
        && (arg.descricaoTamanho === this.descricaoTamanho)
        && (arg.qtd === this.qtd)
        && (arg.item === this.item)
        && (arg.precoTotalItem === this.precoTotalItem)
        && (arg.desconto === this.desconto)
        && (arg.valorLiquido === this.valorLiquido)
        && (arg.precoUnitario === this.precoUnitario)
        && (arg.precoCongelado === this.precoCongelado)
        && (arg.itemControle === this.itemControle)
        && (arg.descricaoMarca === this.descricaoMarca)
        && (arg.gtin === this.gtin)
        && (arg.imgPequenoURL === this.imgPequenoURL)
        && (arg.descricaoCor === this.descricaoCor)
        && (arg.googleCategory === this.googleCategory)
    ;
  }
}


export class LVPedStatsBrowser extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedStatsBrowser";
  browserType: string = "";
  versaoBrowser: string = "";
  browser: string = "";
}


export class DataFrenetPedidoEtiquetaErroVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaErroVit";
  message: string = "";
  details: ArrayList<DataFrenetEtiquetaErroVit> = new ArrayList<DataFrenetEtiquetaErroVit>(DataFrenetEtiquetaErroVit);
}


export class DataFrenetPedidoEtiquetaResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaResponseVit";
  statusBatch: string = "";
  items: ArrayList<DataFrenetPedidoEtiquetaItemResponseVit> = new ArrayList<DataFrenetPedidoEtiquetaItemResponseVit>(DataFrenetPedidoEtiquetaItemResponseVit);
  error: DataFrenetPedidoEtiquetaErroVit = new DataFrenetPedidoEtiquetaErroVit();
}


export class EStatusPedidoPagamentoML {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly none: EStatusPedidoPagamentoML = new EStatusPedidoPagamentoML("0");
  get none() {
    return EStatusPedidoPagamentoML.none;
  }

  static readonly rejected: EStatusPedidoPagamentoML = new EStatusPedidoPagamentoML("1");
  get rejected() {
    return EStatusPedidoPagamentoML.rejected;
  }

  static readonly approved: EStatusPedidoPagamentoML = new EStatusPedidoPagamentoML("2");
  get approved() {
    return EStatusPedidoPagamentoML.approved;
  }

  static readonly cancelled: EStatusPedidoPagamentoML = new EStatusPedidoPagamentoML("3");
  get cancelled() {
    return EStatusPedidoPagamentoML.cancelled;
  }

  static readonly refunded: EStatusPedidoPagamentoML = new EStatusPedidoPagamentoML("4");
  get refunded() {
    return EStatusPedidoPagamentoML.refunded;
  }

  static readonly in_mediation: EStatusPedidoPagamentoML = new EStatusPedidoPagamentoML("5");
  get in_mediation() {
    return EStatusPedidoPagamentoML.in_mediation;
  }

  static readonly charged_back: EStatusPedidoPagamentoML = new EStatusPedidoPagamentoML("6");
  get charged_back() {
    return EStatusPedidoPagamentoML.charged_back;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Pagamento rejeitado";
      case "2": return "Pagamento aprovado";
      case "3": return "Pagamento cancelado";
      case "4": return "Pagamento devolvido";
      case "5": return "Pagamento em media&ccedil;&atilde;o";
      case "6": return "Pagamento em chargeback";
      default: return "";
    }
  }

  public equals(arg: EStatusPedidoPagamentoML): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EStatusPedidoPagamentoML[] = [this.none,this.rejected,this.approved,this.cancelled,this.refunded,this.in_mediation,this.charged_back];
}


export class ConsumidorSiteResponseGetConsumidorV0APP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsumidorSiteResponseGetConsumidorV0APP";
  confirmado: boolean = false;
  pkCliente: PKDependenteAPP = new PKDependenteAPP();
  token: string = "";
  vendedor: boolean = false;
  clienteLocalizado: boolean = false;
  envioConfirmacao: string = "";
  tipoConfirmacao: ETipoConfirmacaoConsumidorSiteAPP = new ETipoConfirmacaoConsumidorSiteAPP();
  urlConsultaVendedor: string = "";
  chaveConfirmacao: number = 0;
}


export class ConsumidorSiteResponseGetConsumidorV1APP extends ConsumidorSiteResponseGetConsumidorV0APP {
  readonly jclass: string = "com.macle.app.vo.ConsumidorSiteResponseGetConsumidorV1APP";
  acessoAppPagtoParc: boolean = false;
}


export class FilterNCE extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FilterNCE";
  descricao: string = "";
  refFornecedor: string = "";
  codTamanho: number = 0;
  nivel2: number = 0;
  promo: boolean = false;
  nivel3: number = 0;
  nivel9: number = 0;
  nivel4: number = 0;
  nivel6: number = 0;
  nivel1: number = 0;
  nivel5: number = 0;
  nivel8: number = 0;
  minFaixaPreco: number = 0;
  maxFaixaPreco: number = 0;
  codMarca: number = 0;
  nivel7: number = 0;
  exibeEstoqueApenasLoja: boolean = false;
  exibeItemZerado: boolean = false;
  codEmpresaLogin: number = 0;
  public equals(arg: FilterNCE): boolean {
    return arg 
        && (arg.descricao === this.descricao)
        && (arg.refFornecedor === this.refFornecedor)
        && (arg.codTamanho === this.codTamanho)
        && (arg.nivel2 === this.nivel2)
        && (arg.promo === this.promo)
        && (arg.nivel3 === this.nivel3)
        && (arg.nivel9 === this.nivel9)
        && (arg.nivel4 === this.nivel4)
        && (arg.nivel6 === this.nivel6)
        && (arg.nivel1 === this.nivel1)
        && (arg.nivel5 === this.nivel5)
        && (arg.nivel8 === this.nivel8)
        && (arg.minFaixaPreco === this.minFaixaPreco)
        && (arg.maxFaixaPreco === this.maxFaixaPreco)
        && (arg.codMarca === this.codMarca)
        && (arg.nivel7 === this.nivel7)
        && (arg.exibeEstoqueApenasLoja === this.exibeEstoqueApenasLoja)
        && (arg.exibeItemZerado === this.exibeItemZerado)
        && (arg.codEmpresaLogin === this.codEmpresaLogin)
    ;
  }
}


export class DataDocVendaItemAPP extends PKTamanhoItemAPP {
  readonly jclass: string = "com.macle.app.vo.DataDocVendaItemAPP";
  descricao: string = "";
  imagem: string = "";
  descricaoTamanho: string = "";
  qtd: number = 0;
}


export class DataDocVendaAPP extends PKDocVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataDocVendaAPP";
  dataEmissao: string = "";
  itens: ArrayList<DataDocVendaItemAPP> = new ArrayList<DataDocVendaItemAPP>(DataDocVendaItemAPP);
  hora: string = "";
}


export class DataDadosClienteEmissaoBoletoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataDadosClienteEmissaoBoletoAPP";
  telefone: string = "";
  nome: string = "";
  endereco: string = "";
  email: string = "";
  enderecoBairro: string = "";
  numeroDocumento: string = "";
  enderecoNumero: string = "";
  enderecoCidade: string = "";
  enderecoEstado: string = "";
  telefoneDDD: string = "";
  enderecoCEP: string = "";
}


export class ConsParcelaLiquidacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsParcelaLiquidacaoAPP";
  dataVencimento: string = "";
  documentoOrigem: string = "";
  numeroTotalParcelas: number = 0;
  parcela: PKParcelaAPP = new PKParcelaAPP();
  dataEmissao: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  vencida: boolean = false;
  numeroParcela: number = 0;
  saldo: number = 0;
}


export class DataConsultaParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataConsultaParcelaAPP";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  dadosCliente: DataDadosClienteEmissaoBoletoAPP = new DataDadosClienteEmissaoBoletoAPP();
  listParcelas: ArrayList<ConsParcelaLiquidacaoAPP> = new ArrayList<ConsParcelaLiquidacaoAPP>(ConsParcelaLiquidacaoAPP);
  listBoletos: ArrayList<DataLiquidacaoParcelaAPP> = new ArrayList<DataLiquidacaoParcelaAPP>(DataLiquidacaoParcelaAPP);
}


export class PKPagamentoParcelaAPP extends PKLiquidacaoParcelaAPP {
  readonly jclass: string = "com.macle.app.vo.PKPagamentoParcelaAPP";
  id: number = 0;
  idPagarmeV5: string = "";

  constructor()
  constructor(codLiquidacaoParcela: number, id: number, idPagarmeV5: string)
  constructor(codLiquidacaoParcela?: number, id?: number, idPagarmeV5?: string) {
    super();
    this.codLiquidacaoParcela = codLiquidacaoParcela || 0;
    this.id = id || 0;
    this.idPagarmeV5 = idPagarmeV5 || "";
  }

  public getPK(): PKPagamentoParcelaAPP {
    return new PKPagamentoParcelaAPP(this.codLiquidacaoParcela, this.id, this.idPagarmeV5);
  }

  public equals(arg: PKPagamentoParcelaAPP): boolean {
    return arg && super.equals(arg)
        && (arg.id === this.id)
        && (arg.idPagarmeV5 === this.idPagarmeV5)
    ;
  }
}


export class EStatusPedido {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EStatusPedido = new EStatusPedido("0");
  get NONE() {
    return EStatusPedido.NONE;
  }

  static readonly PRECONFPAGTO: EStatusPedido = new EStatusPedido("7");
  get PRECONFPAGTO() {
    return EStatusPedido.PRECONFPAGTO;
  }

  static readonly CONFERENCIAPAGTO: EStatusPedido = new EStatusPedido("1");
  get CONFERENCIAPAGTO() {
    return EStatusPedido.CONFERENCIAPAGTO;
  }

  static readonly EMANALISE: EStatusPedido = new EStatusPedido("10");
  get EMANALISE() {
    return EStatusPedido.EMANALISE;
  }

  static readonly APROVADO: EStatusPedido = new EStatusPedido("6");
  get APROVADO() {
    return EStatusPedido.APROVADO;
  }

  static readonly REPROVADO: EStatusPedido = new EStatusPedido("8");
  get REPROVADO() {
    return EStatusPedido.REPROVADO;
  }

  static readonly EXPEDICAO: EStatusPedido = new EStatusPedido("2");
  get EXPEDICAO() {
    return EStatusPedido.EXPEDICAO;
  }

  static readonly EMBARQUE: EStatusPedido = new EStatusPedido("3");
  get EMBARQUE() {
    return EStatusPedido.EMBARQUE;
  }

  static readonly ENTREGUE: EStatusPedido = new EStatusPedido("4");
  get ENTREGUE() {
    return EStatusPedido.ENTREGUE;
  }

  static readonly CANCELADO: EStatusPedido = new EStatusPedido("5");
  get CANCELADO() {
    return EStatusPedido.CANCELADO;
  }

  static readonly DEVOLUCAO: EStatusPedido = new EStatusPedido("9");
  get DEVOLUCAO() {
    return EStatusPedido.DEVOLUCAO;
  }

  static readonly CONTESTADO: EStatusPedido = new EStatusPedido("11");
  get CONTESTADO() {
    return EStatusPedido.CONTESTADO;
  }

  static readonly NAOFINALIZADO: EStatusPedido = new EStatusPedido("12");
  get NAOFINALIZADO() {
    return EStatusPedido.NAOFINALIZADO;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "7": return "";
      case "1": return "Confirma&amp;ccedil;&amp;atilde;o de pagamento";
      case "10": return "Pedido em an&amp;aacute;lise";
      case "6": return "Pedido aprovado";
      case "8": return "Pedido reprovado";
      case "2": return "Preparado para envio";
      case "3": return "Pedido em transporte";
      case "4": return "Pedido entregue";
      case "5": return "Pedido cancelado";
      case "9": return "Pedido devolvido";
      case "11": return "Contestado";
      case "12": return "Pedido nao Finalizado";
      default: return "";
    }
  }

  public equals(arg: EStatusPedido): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EStatusPedido[] = [this.NONE,this.PRECONFPAGTO,this.CONFERENCIAPAGTO,this.EMANALISE,this.APROVADO,this.REPROVADO,this.EXPEDICAO,this.EMBARQUE,this.ENTREGUE,this.CANCELADO,this.DEVOLUCAO,this.CONTESTADO,this.NAOFINALIZADO];
}


export class ETipoPagto {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: ETipoPagto = new ETipoPagto("0");
  get NONE() {
    return ETipoPagto.NONE;
  }

  static readonly PAGSYS: ETipoPagto = new ETipoPagto("1");
  get PAGSYS() {
    return ETipoPagto.PAGSYS;
  }

  static readonly PAGSEGURO: ETipoPagto = new ETipoPagto("2");
  get PAGSEGURO() {
    return ETipoPagto.PAGSEGURO;
  }

  static readonly CIELO: ETipoPagto = new ETipoPagto("3");
  get CIELO() {
    return ETipoPagto.CIELO;
  }

  static readonly ITAU: ETipoPagto = new ETipoPagto("4");
  get ITAU() {
    return ETipoPagto.ITAU;
  }

  static readonly REDECARD: ETipoPagto = new ETipoPagto("5");
  get REDECARD() {
    return ETipoPagto.REDECARD;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Pagsys";
      case "2": return "Pag Seguro";
      case "3": return "Cielo";
      case "4": return "Itau";
      case "5": return "Redecard";
      default: return "";
    }
  }

  public equals(arg: ETipoPagto): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ETipoPagto[] = [this.NONE,this.PAGSYS,this.PAGSEGURO,this.CIELO,this.ITAU,this.REDECARD];
}


export class LVPedFrete extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedFrete";
  CEP: number = 0;
  prazoEntrega: string = "";
  valorFrete: number = 0;
  tipoFrete: ETipoFrete = new ETipoFrete();
  nroObjetoPac: string = "";
}


export class LVPedStats extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVPedStats";
  SO: LVPedStatsSO = new LVPedStatsSO();
  ipCliente: string = "";
  browser: LVPedStatsBrowser = new LVPedStatsBrowser();
}


export class LVDataTransacaoRedecardResult extends BaseData {
  readonly jclass: string = "com.macle.site.vo.LVDataTransacaoRedecardResult";
  data: string = "";
  descricao: string = "";
  codRetorno: number = 0;
  pedido: PKPedido = new PKPedido();
  nroSeqUnico: string = "";
  descricaoRetorno: string = "";
  nroAutenticacao: string = "";
  nroAutorizacao: number = 0;
  nsuAutorizacao: string = "";
  codPaisEmissor: string = "";
  codConfirmacaoAutomatica: number = 0;
}


export class LVPedido extends PKPedido {
  readonly jclass: string = "com.macle.site.vo.LVPedido";
  data: string = "";
  hora: string = "";
  status: EStatusPedido = new EStatusPedido();
  vendedor: LVPKVendedor = new LVPKVendedor();
  tipoPagto: ETipoPagto = new ETipoPagto();
  pedFrete: LVPedFrete = new LVPedFrete();
  pedStats: LVPedStats = new LVPedStats();
  pedCliente: LVPedCliente = new LVPedCliente();
  pedFormaPagto: LVPedFormaPagto = new LVPedFormaPagto();
  requestPedido: number = 0;
  listPedItem: ArrayList<LVPedItem> = new ArrayList<LVPedItem>(LVPedItem);
  pedTransacaoCielo: LVDataTransacaoCieloResult = new LVDataTransacaoCieloResult();
  pedEnderecoComprador: LVPedEndereco = new LVPedEndereco();
  pedEnderecoEntrega: LVPedEndereco = new LVPedEndereco();
  pedTransacaoRedecard: LVDataTransacaoRedecardResult = new LVDataTransacaoRedecardResult();
}


export class DataFrenetShippingServiceResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingServiceResponseVit";
  error: boolean = false;
  shippingPrice: number = 0;
  msg: string = "";
  serviceCode: string = "";
  carrier: string = "";
  deliveryTime: number = 0;
  carrierCode: string = "";
  serviceDescription: string = "";
  originalDeliveryTime: number = 0;
  originalShippingPrice: number = 0;
}


export class DataFrenetShippingResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetShippingResponseVit";
  shippingSevicesArray: ArrayList<DataFrenetShippingServiceResponseVit> = new ArrayList<DataFrenetShippingServiceResponseVit>(DataFrenetShippingServiceResponseVit);
}


export class EClasseItemSite {

  constructor(value?: string) {
    this.value = value || "null";
  }

  static readonly NONE: EClasseItemSite = new EClasseItemSite("null");
  get NONE() {
    return EClasseItemSite.NONE;
  }

  static readonly NORMAL: EClasseItemSite = new EClasseItemSite("'N'");
  get NORMAL() {
    return EClasseItemSite.NORMAL;
  }

  static readonly PROMOCAO: EClasseItemSite = new EClasseItemSite("'P'");
  get PROMOCAO() {
    return EClasseItemSite.PROMOCAO;
  }

  static readonly LANCAMENTO: EClasseItemSite = new EClasseItemSite("'L'");
  get LANCAMENTO() {
    return EClasseItemSite.LANCAMENTO;
  }

  static readonly DESTAQUE: EClasseItemSite = new EClasseItemSite("'D'");
  get DESTAQUE() {
    return EClasseItemSite.DESTAQUE;
  }

  static readonly TODOS_SITE: EClasseItemSite = new EClasseItemSite("'TODOS_SITE'");
  get TODOS_SITE() {
    return EClasseItemSite.TODOS_SITE;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "null": return "";
      case "'N'": return "Normal";
      case "'P'": return "Promo&ccedil;&atilde;o";
      case "'L'": return "Lan&ccedil;amento";
      case "'D'": return "Destaque";
      case "'TODOS_SITE'": return "Todos do site";
      default: return "";
    }
  }

  public equals(arg: EClasseItemSite): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EClasseItemSite[] = [this.NONE,this.NORMAL,this.PROMOCAO,this.LANCAMENTO,this.DESTAQUE,this.TODOS_SITE];
}


export class DataVendaVitrinePublicaAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaVitrinePublicaAPP";
  clienteMacle: ArrayList<PKClienteMacleVitPub> = new ArrayList<PKClienteMacleVitPub>(PKClienteMacleVitPub);
}


export class DataVendaItemAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaItemAPP";
  descricao: string = "";
  itemVit: PKItemLojaVitPub = new PKItemLojaVitPub();
  qtd: number = 0;
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
  desconto: number = 0;
  precoUnitario: number = 0;
  precoCongelado: boolean = false;
}


export class DataEmiteCartaoDeCreditoPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEmiteCartaoDeCreditoPagarMeAPP";
  dadosResumidos: boolean = false;
  telefone: string = "";
  nome: string = "";
  endereco: string = "";
  email: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  enderecoBairro: string = "";
  numeroDocumento: string = "";
  enderecoNumero: string = "";
  enderecoCidade: string = "";
  enderecoEstado: string = "";
  enderecoComplemento: string = "";
  mesValidadeCartao: number = 0;
  vendaVitrinePub: DataVendaVitrinePublicaAPP = new DataVendaVitrinePublicaAPP();
  codigoSegurancaCartao: string = "";
  anoValidadeCartao: number = 0;
  listProduto: ArrayList<DataVendaItemAPP> = new ArrayList<DataVendaItemAPP>(DataVendaItemAPP);
  valor: number = 0;
  telefoneDDD: string = "";
  enderecoCEP: string = "";
  cardHash: string = "";
  numeroCartao: string = "";
  valorFrete: number = 0;
  qtdParcela: number = 0;
  nomeCartao: string = "";
}


export class EModoCreditoClienteVit {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EModoCreditoClienteVit = new EModoCreditoClienteVit("0");
  get NONE() {
    return EModoCreditoClienteVit.NONE;
  }

  static readonly VALOR: EModoCreditoClienteVit = new EModoCreditoClienteVit("1");
  get VALOR() {
    return EModoCreditoClienteVit.VALOR;
  }

  static readonly PERCENT_ITEM: EModoCreditoClienteVit = new EModoCreditoClienteVit("2");
  get PERCENT_ITEM() {
    return EModoCreditoClienteVit.PERCENT_ITEM;
  }

  static readonly PERCENT_VENDA: EModoCreditoClienteVit = new EModoCreditoClienteVit("3");
  get PERCENT_VENDA() {
    return EModoCreditoClienteVit.PERCENT_VENDA;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Valor";
      case "2": return "Percentual item";
      case "3": return "Percentual venda";
      default: return "";
    }
  }

  public equals(arg: EModoCreditoClienteVit): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EModoCreditoClienteVit[] = [this.NONE,this.VALOR,this.PERCENT_ITEM,this.PERCENT_VENDA];
}


export class DataCepAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataCepAPP";
  codCEP: number = 0;
  codUF: string = "";
  bairro: string = "";
  logradouro: string = "";
  cidade: string = "";
}


export class DataRespCanSelect extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataRespCanSelect";
  canSelectText: string = "";
  canSelect: boolean = false;
}


export class DataPedidoItemML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemML";
  item: DataPedidoItemDadosML = new DataPedidoItemDadosML();
  quantity: number = 0;
  listing_type_id: string = "";
  full_unit_price: number = 0;
  unit_price: number = 0;
  sale_fee: number = 0;
}


export class DataFreteVitrineOperadora extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFreteVitrineOperadora";
  nome: string = "";
  codigo: string = "";
  servicos: ArrayList<DataFreteVitrineServico> = new ArrayList<DataFreteVitrineServico>(DataFreteVitrineServico);
}


export class ETipoPrecoVendaAPP {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: ETipoPrecoVendaAPP = new ETipoPrecoVendaAPP("0");
  get NONE() {
    return ETipoPrecoVendaAPP.NONE;
  }

  static readonly PRCITEM: ETipoPrecoVendaAPP = new ETipoPrecoVendaAPP("1");
  get PRCITEM() {
    return ETipoPrecoVendaAPP.PRCITEM;
  }

  static readonly PRCEMPRESA: ETipoPrecoVendaAPP = new ETipoPrecoVendaAPP("2");
  get PRCEMPRESA() {
    return ETipoPrecoVendaAPP.PRCEMPRESA;
  }

  static readonly PRCTAMANHO: ETipoPrecoVendaAPP = new ETipoPrecoVendaAPP("3");
  get PRCTAMANHO() {
    return ETipoPrecoVendaAPP.PRCTAMANHO;
  }

  static readonly PRCEMPTAM: ETipoPrecoVendaAPP = new ETipoPrecoVendaAPP("4");
  get PRCEMPTAM() {
    return ETipoPrecoVendaAPP.PRCEMPTAM;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Pre&ccedil;o do item";
      case "2": return "Pre&ccedil;o por empresa";
      case "3": return "Pre&ccedil;o por tamanho";
      case "4": return "Prc.empresa e tamanho";
      default: return "";
    }
  }

  public equals(arg: ETipoPrecoVendaAPP): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: ETipoPrecoVendaAPP[] = [this.NONE,this.PRCITEM,this.PRCEMPRESA,this.PRCTAMANHO,this.PRCEMPTAM];
}


export class DataSendLiquidaParcelaPagarmeV5APP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendLiquidaParcelaPagarmeV5APP";
  formaPagamento: EFormaPagamentoAPP = new EFormaPagamentoAPP();
  idCobranca: string = "";
  dataPagamento: string = "";
  idPedido: string = "";
  dataEmissaoBoleto: string = "";
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  valorPago: number = 0;
}


export class DataSendDadosEmissaoBoletoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendDadosEmissaoBoletoAPP";
  dadosEmissaoAPP: string = "";
  versaoEmissaoAPP: EVersaoIntegracaoPagarmeAPP = new EVersaoIntegracaoPagarmeAPP();
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
}


export class DataSendLiquidaParcelaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendLiquidaParcelaAPP";
  formaPagamento: EFormaPagamentoAPP = new EFormaPagamentoAPP();
  dataPagamento: string = "";
  idTransacao: number = 0;
  dataEmissaoBoleto: string = "";
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  valorPago: number = 0;
  idPagamento: number = 0;
}


export class FilterLiquidacaoAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FilterLiquidacaoAPP";
}


export class DataFrenetCotacaoServicoVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetCotacaoServicoVit";
  declaredValue: boolean = false;
  ownHand: boolean = false;
  receiptNotification: boolean = false;
}


export class DataFrenetCotacaoServicoResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetCotacaoServicoResponseVit";
  error: boolean = false;
  shippingPrice: number = 0;
  msg: string = "";
  carrier: string = "";
  deliveryTime: number = 0;
  carrierCode: string = "";
  platformShippingPrice: number = 0;
  shippingServiceCode: string = "";
  shippingServiceName: string = "";
  services: DataFrenetCotacaoServicoVit = new DataFrenetCotacaoServicoVit();
  shippingCompetitorPrice: number = 0;
}


export class DataFrenetCotacaoResponseVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetCotacaoResponseVit";
  quotations: ArrayList<DataFrenetCotacaoServicoResponseVit> = new ArrayList<DataFrenetCotacaoServicoResponseVit>(DataFrenetCotacaoServicoResponseVit);
  sessionId: string = "";
  shippingServiceCodeSelect: string = "";
}


export class DataVendaEntregaAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaEntregaAPP";
  codClienteMacle: PKClienteMacleVitPub = new PKClienteMacleVitPub();
  frete: DataFreteAPP = new DataFreteAPP();
  codEmpresaRetiradaLoja: number = 0;
  distancia: DataEntregaDistanciaAPP = new DataEntregaDistanciaAPP();
  taxaEntrega: number = 0;
  cotacaoFrenet: DataFrenetCotacaoResponseVit = new DataFrenetCotacaoResponseVit();
  retiradaLoja: boolean = false;
}


export class DataFreteVitrinePubAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataFreteVitrinePubAPP";
  codClienteMacle: number = 0;
  nomeLoja: string = "";
  frete: ArrayList<DataFreteAPP> = new ArrayList<DataFreteAPP>(DataFreteAPP);
}


export class DataPedidoEntregaLimiteEnvioML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaLimiteEnvioML";
  date: string = "";
}


export class DataPedidoEntregaOpcaoEnvioML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaOpcaoEnvioML";
  estimated_delivery_limit: DataPedidoEntregaLimiteEnvioML = new DataPedidoEntregaLimiteEnvioML();
}


export class EStatusProdutoML {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EStatusProdutoML = new EStatusProdutoML("0");
  get NONE() {
    return EStatusProdutoML.NONE;
  }

  static readonly active: EStatusProdutoML = new EStatusProdutoML("1");
  get active() {
    return EStatusProdutoML.active;
  }

  static readonly closed: EStatusProdutoML = new EStatusProdutoML("2");
  get closed() {
    return EStatusProdutoML.closed;
  }

  static readonly paused: EStatusProdutoML = new EStatusProdutoML("3");
  get paused() {
    return EStatusProdutoML.paused;
  }

  static readonly under_review: EStatusProdutoML = new EStatusProdutoML("4");
  get under_review() {
    return EStatusProdutoML.under_review;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Ativo";
      case "2": return "Inativo";
      case "3": return "Pausado";
      case "4": return "Em revis&atilde;o";
      default: return "";
    }
  }

  public equals(arg: EStatusProdutoML): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EStatusProdutoML[] = [this.NONE,this.active,this.closed,this.paused,this.under_review];
}


export class DataPedidoEntregaML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaML";
  base_cost: number = 0;
  logistic_type: string = "";
  receiver_id: number = 0;
  sender_id: number = 0;
  shipping_option: DataPedidoEntregaOpcaoEnvioML = new DataPedidoEntregaOpcaoEnvioML();
  receiver_address: DataEnderecoML = new DataEnderecoML();
  tracking_number: string = "";
  tracking_method: string = "";
}


export class DataVendaFormaPagamentoAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaFormaPagamentoAPP";
  formaPagamento: EFormaPagamentoAPP = new EFormaPagamentoAPP();
  idPedidoPagarme: string = "";
  cartao: DataResultEmiteCartaoDeCreditoPagarMeAPP = new DataResultEmiteCartaoDeCreditoPagarMeAPP();
  pix: DataResultEmiteVendaPixPagarMeAPP = new DataResultEmiteVendaPixPagarMeAPP();
  boleto: DataResultEmiteBoletoPagarMeAPP = new DataResultEmiteBoletoPagarMeAPP();
  condVenda: PKCondVendaAPP = new PKCondVendaAPP();
  idCobrancaPagarme: string = "";
}


export class DataVendaEnderecoAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaEnderecoAPP";
  endereco: DataEndereco = new DataEndereco();
}


export class DataVendaAPP extends PKVendaAPP {
  readonly jclass: string = "com.macle.app.vo.DataVendaAPP";
  data: string = "";
  cliente: DataVendaClienteAPP = new DataVendaClienteAPP();
  formaPagamento: DataVendaFormaPagamentoAPP = new DataVendaFormaPagamentoAPP();
  valor: number = 0;
  hora: string = "";
  enviadoSistema: boolean = false;
  codVitrineVenda: number = 0;
  idPedidoEntregaML: number = 0;
  codEmpresaVenda: number = 0;
  pagarMeTransacao: PKPagarMeTransacaoAPP = new PKPagarMeTransacaoAPP();
  enderecoEntrega: DataVendaEnderecoAPP = new DataVendaEnderecoAPP();
  vendaFinalizada: boolean = false;
  enviadoVitrine: boolean = false;
  desconto: number = 0;
  listItem: ArrayList<DataVendaItemAPP> = new ArrayList<DataVendaItemAPP>(DataVendaItemAPP);
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  listEntrega: ArrayList<DataVendaEntregaAPP> = new ArrayList<DataVendaEntregaAPP>(DataVendaEntregaAPP);
  pkVendaVit: PKVendaVit = new PKVendaVit();
  idPedidoML: number = 0;
}


export class DataPedidoPaginacaoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoPaginacaoML";
  offset: number = 0;
  total: number = 0;
  limit: number = 0;
}


export class DataPedidoPagamentoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoPagamentoML";
  id: number = 0;
  status: any;
  transaction_amount_refunded: number = 0;
  total_paid_amount: number = 0;
  payment_method_id: string = "";
  transaction_amount: number = 0;
  payer_id: number = 0;
  order_id: number = 0;
  reason: string = "";
  installments: number = 0;
  date_created: string = "";
}


export class DataPedidoMediadorML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoMediadorML";
  id: number = 0;
}


export class DataPedidoCompradorML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoCompradorML";
  id: number = 0;
  nickname: string = "";
}


export class DataPedidoResultML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoResultML";
  id: number = 0;
  cliente: DataPedidoClienteML = new DataPedidoClienteML();
  status: any;
  date_last_updated: string = "";
  expiration_date: string = "";
  payments: ArrayList<DataPedidoPagamentoML> = new ArrayList<DataPedidoPagamentoML>(DataPedidoPagamentoML);
  date_created: string = "";
  last_updated: string = "";
  order_items: ArrayList<DataPedidoItemML> = new ArrayList<DataPedidoItemML>(DataPedidoItemML);
  mediations: ArrayList<DataPedidoMediadorML> = new ArrayList<DataPedidoMediadorML>(DataPedidoMediadorML);
  paid_amount: number = 0;
  date_closed: string = "";
  entrega: DataPedidoEntregaML = new DataPedidoEntregaML();
  shipping: DataPedidoShippingML = new DataPedidoShippingML();
  pack_id: number = 0;
  total_amount: number = 0;
  buyer: DataPedidoCompradorML = new DataPedidoCompradorML();
  seller: DataPedidoCompradorML = new DataPedidoCompradorML();
}


export class DataPedidoML extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoML";
  query: string = "";
  display: string = "";
  paging: DataPedidoPaginacaoML = new DataPedidoPaginacaoML();
  results: ArrayList<DataPedidoResultML> = new ArrayList<DataPedidoResultML>(DataPedidoResultML);
}


export class FiltroNodeItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FiltroNodeItemAPP";
  descricao: string = "";
  codigo: number = 0;
  quantidade: number = 0;
}


export class FiltroNodeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.FiltroNodeAPP";
  value: number = 0;
  nome: string = "";
  visivel: boolean = false;
  lista: ArrayList<FiltroNodeItemAPP> = new ArrayList<FiltroNodeItemAPP>(FiltroNodeItemAPP);
  display: string = "";
}


export class DataSendLiquidaParcelaZoopAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendLiquidaParcelaZoopAPP";
  codEmpresa: number = 0;
  formaPagamento: EFormaPagamentoAPP = new EFormaPagamentoAPP();
  conta: PKContaAPP = new PKContaAPP();
  dataPagamento: string = "";
  dataEmissaoBoleto: string = "";
  idTransacaoPIX: string = "";
  transactionID: string = "";
  listPkParc: ArrayList<PKParcelaAPP> = new ArrayList<PKParcelaAPP>(PKParcelaAPP);
  horaPagamento: string = "";
  valorPago: number = 0;
}


export class DataPedidoEntregaVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoEntregaVit";
  frete: DataFreteAPP = new DataFreteAPP();
  codEmpresaRetiradaLoja: number = 0;
  distancia: DataEntregaDistanciaAPP = new DataEntregaDistanciaAPP();
  taxaEntrega: number = 0;
  retiradaLoja: boolean = false;
}


export class DataZoopTransacaoAPP extends PKZoopTransacaoAPP {
  readonly jclass: string = "com.macle.app.vo.DataZoopTransacaoAPP";
  data: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  hora: string = "";
  status: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP();
  idCobranca: string = "";
  idTransacao: number = 0;
  statusCartao: EStatusPedidoCartaoCreditoPagarmeAPP = new EStatusPedidoCartaoCreditoPagarmeAPP();
  idPedido: string = "";
  jsonTransacao: string = "";
}


export class DataContaAPP extends PKContaAPP {
  readonly jclass: string = "com.macle.app.vo.DataContaAPP";
  descricao: string = "";
  idSeller: string = "";
}


export class DataMedidaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataMedidaItemVit";
  comprimentoCM: number = 0;
  pesoGramas: number = 0;
  alturaCM: number = 0;
  larguraCM: number = 0;
}


export class EStatusPedidoML {

  constructor(value?: string) {
    this.value = value || "0";
  }

  static readonly NONE: EStatusPedidoML = new EStatusPedidoML("0");
  get NONE() {
    return EStatusPedidoML.NONE;
  }

  static readonly confirmed: EStatusPedidoML = new EStatusPedidoML("1");
  get confirmed() {
    return EStatusPedidoML.confirmed;
  }

  static readonly payment_required: EStatusPedidoML = new EStatusPedidoML("2");
  get payment_required() {
    return EStatusPedidoML.payment_required;
  }

  static readonly payment_in_process: EStatusPedidoML = new EStatusPedidoML("3");
  get payment_in_process() {
    return EStatusPedidoML.payment_in_process;
  }

  static readonly partially_paid: EStatusPedidoML = new EStatusPedidoML("4");
  get partially_paid() {
    return EStatusPedidoML.partially_paid;
  }

  static readonly paid: EStatusPedidoML = new EStatusPedidoML("5");
  get paid() {
    return EStatusPedidoML.paid;
  }

  static readonly partially_refunded: EStatusPedidoML = new EStatusPedidoML("6");
  get partially_refunded() {
    return EStatusPedidoML.partially_refunded;
  }

  static readonly pending_cancel: EStatusPedidoML = new EStatusPedidoML("7");
  get pending_cancel() {
    return EStatusPedidoML.pending_cancel;
  }

  static readonly cancelled: EStatusPedidoML = new EStatusPedidoML("8");
  get cancelled() {
    return EStatusPedidoML.cancelled;
  }

  static readonly invalid: EStatusPedidoML = new EStatusPedidoML("9");
  get invalid() {
    return EStatusPedidoML.invalid;
  }

  public toDisplay(): string {
    switch (this.value) {
      case "0": return "";
      case "1": return "Status inicial de uma order; ainda sem ter sido paga.";
      case "2": return "O pagamento da order deve ter sido confirmado para exibir as informa&ccedil;&otilde;es do usu&aacute;rio.";
      case "3": return "H&aacute; um pagamento relacionado � order, mais ainda n&atilde;o foi aprovado.";
      case "4": return "A order tem um pagamento associado creditado, por&eacute;m, insuficiente.";
      case "5": return "A order tem um pagamento associado aprovado.";
      case "6": return "A order tem devolu&ccedil;&otilde;es paciais de seus pagamentos.";
      case "7": return "Quando a order foi cancelada mas temos dificultdade para devolver o pagamento.";
      case "8": return "Por alguma raz&atilde;o, a order n&atilde;o foi completada.";
      case "9": return "A order foi invalidada por vir de um comprador malicioso.";
      default: return "";
    }
  }

  public equals(arg: EStatusPedidoML): boolean {
    return arg && this.value === arg.value;
  }

  value: string;
  enums: EStatusPedidoML[] = [this.NONE,this.confirmed,this.payment_required,this.payment_in_process,this.partially_paid,this.paid,this.partially_refunded,this.pending_cancel,this.cancelled,this.invalid];
}


export class ConsCorItemAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsCorItemAPP";
  nome: string = "";
  codItem: number = 0;
  codEmpItem: number = 0;
  imagem: string = "";

  constructor()
  constructor(codEmpItem: number, codItem: number, nome: string, imagem: string)
  constructor(codEmpItem?: number, codItem?: number, nome?: string, imagem?: string) {
    super();
    this.codEmpItem = codEmpItem || 0;
    this.codItem = codItem || 0;
    this.nome = nome || "";
    this.imagem = imagem || "";
  }

  public getPK(): ConsCorItemAPP {
    return new ConsCorItemAPP(this.codEmpItem, this.codItem, this.nome, this.imagem);
  }

  public equals(arg: ConsCorItemAPP): boolean {
    return arg 
        && (arg.nome === this.nome)
        && (arg.codItem === this.codItem)
        && (arg.codEmpItem === this.codEmpItem)
        && (arg.imagem === this.imagem)
    ;
  }
}


export class DataFreteVitrine extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFreteVitrine";
  codigo: string = "";
  operadoras: ArrayList<DataFreteVitrineOperadora> = new ArrayList<DataFreteVitrineOperadora>(DataFreteVitrineOperadora);
}


export class PKItemHashtagVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.PKItemHashtagVit";
  codHashtag: number = 0;

  constructor()
  constructor(codHashtag: number)
  constructor(codHashtag?: number) {
    super();
    this.codHashtag = codHashtag || 0;
  }

  public getPK(): PKItemHashtagVit {
    return new PKItemHashtagVit(this.codHashtag);
  }

  public equals(arg: PKItemHashtagVit): boolean {
    return arg 
        && (arg.codHashtag === this.codHashtag)
    ;
  }
}


export class DataItemHashTagVit extends PKItemHashtagVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataItemHashTagVit";
  hashtag: string = "";
}


export class DataParametrosAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataParametrosAPP";
  logoBase64: string = "";
  telefone: string = "";
  fantasia: string = "";
  whatsApp: number = 0;
  valorTaxaEntregaCompraAPP: number = 0;
  ativo: boolean = false;
  tokenFrenet: string = "";
  CNPJ: string = "";
  urlAPP: string = "";
  lconta: ArrayList<DataContaAPP> = new ArrayList<DataContaAPP>(DataContaAPP);
  macleID: string = "";
  idSellerZoop: string = "";
  taxaBoletoLiquidacaoParcelaAplicativo: number = 0;
  habilitaVisMensagemCompraWhatsAPP: boolean = false;
  codEmpresaLiquidacaoParcelaAplicativo: number = 0;
  valorTaxaEntregaCondicionalAPP: number = 0;
  habilitaSomenteConsultaParcelaAPP: boolean = false;
  distanciaMaximaEntregaCondicionalAPP: number = 0;
  habilitaConsultaEstoqueVendedor: boolean = false;
  codContaBoletoLiquidacaoParcelaAplicativo: number = 0;
  valorTaxaEntregaCompraAbaixoDeAPP: number = 0;
  distanciaMaximaEntregaCompraAPP: number = 0;
  distanciaEntregaGratisCompraAPP: number = 0;
  codEmpresaContaBoletoLiquidacaoParcelaAplicativo: number = 0;
  codAdmContratoSigepAPP: string = "";
  tipoFreteGratisCorreioAPP: ETipoFrete = new ETipoFrete();
  habilitaRetiradaLojaCompraAPP: boolean = false;
  habilitaCondicionalAPP: boolean = false;
  habilitaEntregaCorreiosAPP: boolean = false;
  codigoServicoSedexSigepAPP: number = 0;
  empresaRetirataMercadoriaAPP: string = "";
  valorFreteGratisCorreioAPP: number = 0;
  habilitaEntregaCompraAPP: boolean = false;
  habilitaPIXParcelaAPP: boolean = false;
  pctDescontoCompraPIXAPP: number = 0;
  cepOrigemSigepAPP: number = 0;
  codigoServicoPacSigepAPP: number = 0;
  habilitaPIXCompraAPP: boolean = false;
  appVitrinePublica: boolean = false;
  cnpjContratoSigepAPP: string = "";
  habilitaBoletoParcelaAPP: boolean = false;
  taxaBoletoAbaixoDeAPP: number = 0;
  servidorConsulta: string = "";
  chaveCriptografiaPagarMe: string = "";
  habilitaLiquidacaoParcelaAPP: boolean = false;
  habilitaComprasAPP: boolean = false;
  habilitaCrediarioCompraAPP: boolean = false;
  dataReferencia: string = "";
  pctDescontoBoletoAPP: number = 0;
  qtdMaxParcelaAPP: number = 0;
  habilitaCartaoCompraAPP: boolean = false;
  qtdMaxParcelaCrediarioAPP: number = 0;
  valorMinParcelaCrediarioAPP: number = 0;
  valorMinParcelaAPP: number = 0;
  chaveAPIPagarMe: string = "";
  diasValidadeLinkVendedorAPP: number = 0;
  habilitaBoletoCompraAPP: boolean = false;
  pctDescontoCreditoCartaoAPP: number = 0;
}


export class DataSendStatusVendaAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendStatusVendaAPP";
  status: EStatusPagarMeTransacaoAPP = new EStatusPagarMeTransacaoAPP();
  venda: PKVendaAPP = new PKVendaAPP();
}


export class DataPagamentoParcelaAPP extends PKPagamentoParcelaAPP {
  readonly jclass: string = "com.macle.app.vo.DataPagamentoParcelaAPP";
  valor: number = 0;
  dataPagamento: string = "";
  dataCriacao: string = "";
}


export class DataEmiteBoletoPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEmiteBoletoPagarMeAPP";
  dadosResumidos: boolean = false;
  telefone: string = "";
  nome: string = "";
  endereco: string = "";
  email: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  enderecoBairro: string = "";
  numeroDocumento: string = "";
  enderecoNumero: string = "";
  enderecoCidade: string = "";
  enderecoEstado: string = "";
  liquidacao: DataLiquidacaoParcelaAPP = new DataLiquidacaoParcelaAPP();
  valor: number = 0;
  telefoneDDD: string = "";
  enderecoCEP: string = "";
}


export class ConsCondVendaAuxAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsCondVendaAuxAPP";
  listCondVenda: ArrayList<ConsCondVendaAPP> = new ArrayList<ConsCondVendaAPP>(ConsCondVendaAPP);
}


export class DataPedidoItemVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoItemVit";
  descricao: string = "";
  itemVit: PKTamanhoItemVit = new PKTamanhoItemVit();
  qtd: number = 0;
  item: PKTamanhoItemAPP = new PKTamanhoItemAPP();
  desconto: number = 0;
  precoUnitario: number = 0;
}


export class DataPedidoVit extends PKPedidoVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataPedidoVit";
  data: string = "";
  cliente: DataPedidoClienteVit = new DataPedidoClienteVit();
  formaPagamento: DataPedidoFormaPagamentoVit = new DataPedidoFormaPagamentoVit();
  valor: number = 0;
  hora: string = "";
  status: EStatusPedidoSite = new EStatusPedidoSite();
  enviadoSistema: boolean = false;
  pagarMeTransacao: DataPedidoPagarMeTransacaoVit = new DataPedidoPagarMeTransacaoVit();
  enderecoEntrega: DataPedidoEnderecoVit = new DataPedidoEnderecoVit();
  desconto: number = 0;
  listItem: ArrayList<DataPedidoItemVit> = new ArrayList<DataPedidoItemVit>(DataPedidoItemVit);
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  idPedidoML: number = 0;
  cotacaoFrenet: DataFrenetCotacaoResponseVit = new DataFrenetCotacaoResponseVit();
  nroetiquetasigep: string = "";
  horaUltimoUpdate: string = "";
  codEmpresaPedido: number = 0;
  dataUltimoUpdate: string = "";
  dataCancelamento: string = "";
  pedidoML: DataPedidoResultML = new DataPedidoResultML();
  acrescimo: number = 0;
  entrega: DataPedidoEntregaVit = new DataPedidoEntregaVit();
}


export class DataEntregaLojaVitrinePubAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEntregaLojaVitrinePubAPP";
  valorTaxaEntregaCompraAPP: number = 0;
  codClienteMacle: number = 0;
  nomeLoja: string = "";
  distanciaKM: number = 0;
  distanciaMaximaEntregaCompraAPP: number = 0;
  distanciaEntregaGratisCompraAPP: number = 0;
}


export class DataFrenetPedidoEtiquetaVolumeVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaVolumeVit";
  length: number = 0;
  height: number = 0;
  weight: number = 0;
  width: number = 0;
  price: number = 0;
  declaredValue: number = 0;
  volumeId: number = 0;
}


export class DataFrenetPedidoEtiquetaVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataFrenetPedidoEtiquetaVit";
  volumes: DataFrenetPedidoEtiquetaVolumeVit = new DataFrenetPedidoEtiquetaVolumeVit();
  shipmentId: number = 0;
  order: DataFrenetPedidoEtiquetaOrdemVit = new DataFrenetPedidoEtiquetaOrdemVit();
  quotation: DataFrenetCotacaoServicoResponseVit = new DataFrenetCotacaoServicoResponseVit();
  branchCode: string = "";
  trackingNotificationUrl: string = "";
  shipmentStatus: number = 0;
  statusNotificationUrl: string = "";
}


export class ConsItemAPP extends LVPKItem {
  readonly jclass: string = "com.macle.app.vo.ConsItemAPP";
  descricao: string = "";
  tipo: string = "";
  itemVit: PKItemLojaVitPub = new PKItemLojaVitPub();
  refFornecedor: string = "";
  tipoPreco: ETipoPrecoVendaAPP = new ETipoPrecoVendaAPP();
  marca: string = "";
  tamanhos: ArrayList<ConsTamanhoItemAPP> = new ArrayList<ConsTamanhoItemAPP>(ConsTamanhoItemAPP);
  precos: ArrayList<DataPrecoVendaAPP> = new ArrayList<DataPrecoVendaAPP>(DataPrecoVendaAPP);
  promocao: boolean = false;
  precoTabela: number = 0;
  preco: number = 0;
  cores: ArrayList<ConsCorItemAPP> = new ArrayList<ConsCorItemAPP>(ConsCorItemAPP);
  imagens: string[] = [];
}


export class DataVendaVit extends PKVendaVit {
  readonly jclass: string = "com.macle.vitrine.vo.DataVendaVit";
  data: string = "";
  valor: number = 0;
  hora: string = "";
  codVitrineVenda: number = 0;
  codEmpresaVenda: number = 0;
  desconto: number = 0;
  listItem: ArrayList<DataVendaItemVit> = new ArrayList<DataVendaItemVit>(DataVendaItemVit);
  vendedor: PKVendedorAPP = new PKVendedorAPP();
  precoTotalVenda: number = 0;
  qtdItensVenda: number = 0;
}


export class ConsumidorSiteResponseChaveConfirmacaoValida extends BaseData {
  readonly jclass: string = "com.macle.app.vo.ConsumidorSiteResponseChaveConfirmacaoValida";
  pkCliente: PKDependenteAPP = new PKDependenteAPP();
  token: string = "";
  chaveConfirmacaoValida: boolean = false;
}


export class DataResultEmiteBoletoZoopAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataResultEmiteBoletoZoopAPP";
  barcodeBoleto: string = "";
  urlBoleto: string = "";
  pkTransacao: PKZoopTransacaoAPP = new PKZoopTransacaoAPP();
  valorBoleto: number = 0;
  valorBoletoSemTaxa: number = 0;
  vencimentoBoleto: string = "";
}


export class DataSendStatusPedido extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataSendStatusPedido";
  status: EStatusPedidoSite = new EStatusPedidoSite();
  venda: PKPedidoVit = new PKPedidoVit();
}


export class DataMarcaItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataMarcaItemVit";
  descricaoMarca: string = "";
  codigoMarca: number = 0;
}


export class DataEmiteBoletoVendaPagarMeAPP extends BaseData {
  readonly jclass: string = "com.macle.app.vo.DataEmiteBoletoVendaPagarMeAPP";
  dadosResumidos: boolean = false;
  telefone: string = "";
  nome: string = "";
  endereco: string = "";
  email: string = "";
  cliente: PKDependenteAPP = new PKDependenteAPP();
  enderecoBairro: string = "";
  numeroDocumento: string = "";
  enderecoNumero: string = "";
  enderecoCidade: string = "";
  enderecoEstado: string = "";
  vendaVitrinePub: DataVendaVitrinePublicaAPP = new DataVendaVitrinePublicaAPP();
  listProduto: ArrayList<DataVendaItemAPP> = new ArrayList<DataVendaItemAPP>(DataVendaItemAPP);
  valor: number = 0;
  telefoneDDD: string = "";
  enderecoCEP: string = "";
}


export class DataTipoItemVit extends BaseData {
  readonly jclass: string = "com.macle.vitrine.vo.DataTipoItemVit";
  descricaoTipo: string = "";
  codigoTipo: number = 0;
}


